unit U_Main;

{ -------------------------------------------------------------------------------
  Main form for the TMS WEB Core client.

  Responsibilities (high level):
  - Handle login / logout and keep the selected ressource in localStorage.
  - Drive the UI tabs (presence, recap, correction, etc.).
  - Call the REST API through TApiClient (U_ApiClient) and render results.

  Notes:
  - Per request, any commented-out code has been removed to keep the unit clean.
  - The executable code (non-commented) is intentionally left unchanged.
  ------------------------------------------------------------------------------- }
interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, WEBLib.REST, WEBLib.JSON, U_Model, jsdelphisystem, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.WebCtrls, WEBLib.ClientConnector,
  WEBLib.ComCtrls, WEBLib.Toast, WEBLib.Storage, U_ApiClient;

const
  PRESENCE_AFF_ID = 1;
  PAUSE_AFF_ID = 6;

  // localStorage keys (safe, no JWT stored)
  LS_RESSOURCE_ID = 'active_ressource_id';
  LS_RESSOURCE_CODE = 'active_ressource_code';

type
  TTokenCallback = reference to procedure(const Token: string);

type
  TForm_Main = class(TForm)
    WebHTMLDiv_EntetePresence: THTMLDiv;
    lblPresence: TLabel;
    WebPageControl_Main: TPageControl;
    WebPageControl_Main_Identification: TTabSheet;
    WebHTMLDiv2: THTMLDiv;
    btnLogin: TButton;
    WebHTMLDiv3: THTMLDiv;
    lbl_identifiant: TLabel;
    edtUsername: TEdit;
    WebPageControl_Main_Presence: TTabSheet;
    WebHTMLDiv1: THTMLDiv;
    divTileContainer: THTMLDiv;
    divPresenceDebutBtn: THTMLDiv;
    divPresenceFinBtn: THTMLDiv;
    divPauseDebutBtn: THTMLDiv;
    divPauseFinBtn: THTMLDiv;
    divTimbrages: THTMLDiv;
    WebTabSheet_Recapitulatif: TTabSheet;
    WebHTMLDiv4: THTMLDiv;
    WebHTMLDiv_RecapTitre: THTMLDiv;
    WebHTMLDiv_RecapSoldeDuJour: THTMLDiv;
    WebHTMLDiv_RecapSemainePrevu: THTMLDiv;
    WebHTMLDiv_RecapSemaineRealise: THTMLDiv;
    WebHTMLDiv_RecapSemaineSolde: THTMLDiv;
    WebHTMLDiv_RecapMoisEncours: THTMLDiv;
    WebHTMLDiv_RecapAnneeEnCours: THTMLDiv;
    WebHTMLDiv_RecapTitreVacance: THTMLDiv;
    WebHTMLDiv_RecapVacanceConvenu: THTMLDiv;
    WebHTMLDiv_RecapVacanceSoldeMois1: THTMLDiv;
    WebHTMLDiv_RecapVacanceRealisePlanifie: THTMLDiv;
    WebHTMLDiv_RecapVacanceSoldeDispo: THTMLDiv;
    WebHTMLDiv5: THTMLDiv;
    WebHTMLDiv6: THTMLDiv;
    WebHTMLDiv7: THTMLDiv;
    btnLogout: TButton;
    WebButton1: TButton;
    WebPageControl_Main_Correction: TTabSheet;
    WebHTMLDiv8: THTMLDiv;
    WebHTMLDiv_Correction_Top: THTMLDiv;
    divTimbragesCorrection: THTMLDiv;
    WebLabel1: TLabel;
    WebLabel_Correction_DateHeure: TLabel;
    WebLabel2: TLabel;
    WebDateTimePicker_CorrectionHeure: TDateTimePicker;
    WebButton_Correction_Valider: TButton;
    WebLabel3: TLabel;
    WebHTMLDiv9: THTMLDiv;
    WebButton_DarkLight: TButton;
    LocalStorage1: TLocalStorage;
    WebPageControl_Main_DemandeVac: TTabSheet;
    divDemandeVacContainer: THTMLDiv;
    divDemandeForm: THTMLDiv;
    // divDemandeFormInner: TWebHTMLDiv;
    // lblDemandeFormTitre: TWebLabel;
    // lblDateDebut: TWebLabel;
    // dtpDateDebut: TWebDateTimePicker;
    // lblDateFin: TWebLabel;
    // dtpDateFin: TWebDateTimePicker;
    // lblMotif: TWebLabel;
    // cboMotif: TWebComboBox;
    // divPeriodeChoix: TWebHTMLDiv;
    // divHeures: TWebHTMLDiv;
    // dtpHeureDebut: TWebDateTimePicker;
    // lblHeureDebut: TWebLabel;
    // lblHeureFin: TWebLabel;
    // dtpHeureFin: TWebDateTimePicker;
    // btnEnvoyerDemande: TWebButton;
    // btnAnnulerDemande: TWebButton;
    divDemandesList: THTMLDiv;
    procedure btnLogoutClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnLoginClick(Sender: TObject);
    procedure edtUsernameKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebTabSheet_RecapitulatifShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton_Correction_ValiderClick(Sender: TObject);
    procedure WebButton_DarkLightClick(Sender: TObject);
    procedure WebTabSheet_DemandeVacShow(Sender: TObject);
    // procedure btnEnvoyerDemandeClick(Sender: TObject);
    // procedure btnAnnulerDemandeClick(Sender: TObject);
  private
    { Private state }
    // Everything below is internal to the form and is driven by UI events.

    // Base URL of the backend API (built at runtime depending on hosting).

    BaseApiUrl: String;
    // Currently selected employee / user (loaded after login, restored after reload).
    RessourceActive: TRessource;
    // Currently running presence (if any), as returned by the API.
    PresenceActive: TPresence;
    // Currently running pause (if any), as returned by the API.
    PauseActive: TPresence;
    // Champ pour savoir si la pause est masquée car automatique
    FMasquePause: Boolean;
    // Callback used to continue the workflow after a successful login.
    FOnLoginSuccess: TTokenCallback;
    // UI theme (applied to document body / CSS classes).
    FTheme: string; // 'theme-light' or 'theme-dark'
    // Small REST wrapper used by this form to call the backend API.

    FApi: TApiClient;

    // --- Local persistence (localStorage) -------------------------------------
    // We store only the active ressource information (no JWT) so refresh is seamless.

    { --- Demandes vacances --- }
    FMotifs: TJSArray; // liste des motifs chargés du serveur
    FPeriodeSelectionnee: string; // 'journee', 'matin', 'apresmidi', 'libre'
    FHeuresParJour: Double; // heures/jour retournées par l'API

    procedure SaveActiveRessourceToStorage;
    procedure ClearActiveRessourceFromStorage;
    function LoadStoredRessourceId: Integer;
    function LoadStoredRessourceCode: string;
    procedure RestoreRessourceAfterReload;
    procedure ShowSessionLoader;
    procedure RemoveSessionLoader;
    // --- Presence / pause actions ----------------------------------------------
    procedure DefineOnStartPresence;
    procedure OnStartPresenceHandler;
    procedure OnEndPresenceHandler;
    procedure OnStartPauseHandler;
    procedure OnEndPauseHandler;
    procedure CheckSessionAndShowUI;
    procedure ClearFields(_onlyPresence: Boolean);
    procedure GetRessourceInfo;
    procedure DoLogin;
    procedure FetchRessourceInfo();
    Procedure addWithCredentials(var _httpGet: THttpRequest);
    procedure HandleFetchRessourceInfoResponse(AResponse: string);
    procedure FetchActivePresenceForRessource(const _ressourceId: Integer);
    procedure HandleFetchActivePresenceForRessourceResponse(AResponse: string);
    // --- UI navigation (tab switching / panels) --------------------------------
    procedure ShowLoginPanel;
    procedure ShowMainMenu;
    procedure ShowCorrectionPanel;
    procedure FetchSaisiePresenceTodayForRessource(RessourceID: Integer);
    // Backward-compatible handler names (old U_Main expected these)
    procedure HandleFetchSaisiePresenceTodayResponse(AResponse: string);

    procedure HandleFetchSaisiePresenceTodayForRessourceResponse
      (AResponse: string);
    procedure FetchSaisiePresenceForDayAndRessource(_date: TDate;
      RessourceID: Integer);
    procedure HandleFetchSaisiePresenceForDayResponse(AResponse: string);

    procedure HandleFetchSaisiePresenceForDateAndRessourceResponse
      (AResponse: string);
    procedure HandleSecureResponse(Sender: TObject; AResponse: string);
    procedure HandleSecureError(Sender: TObject; AMessage: string);
    procedure HandleHttpError(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
    // --- JSON parsing / rendering ------------------------------------------------
    // Parsing is kept manual to avoid heavy RTTI and to keep payload mapping explicit.
    function ParseRessourceFromJSON(const AJSON: string): TRessource;
    function ParsePresencesFromJSON(const AJSON: string): TJSArray;
    function CreatePresenceFromObject(const Obj: TJSObject): TPresence;
    function RenderTimbrages(const Timbrages: TJSArray): string;
    Procedure RenderStatsFromJSON(const AJSON: string);
    Function getDivForStatField(_titre, _valeur: string): String;
    procedure ShowLoginError;
    procedure showToast(const Msg: string; const ToastType: string = 'success');
    procedure PostDebutPresenceRest(_pause: Boolean);
    procedure PostFinPresenceRest(_pause: Boolean);
    procedure PostFinPresenceCorrectionRest(_heureFin: ttime);
    procedure FetchRessourceStats();
    procedure ProcessLoginSuccess(const AResponse: string);
    procedure HandleHttpResponseTextBased(const AResponse: string;
      const SuccessMsg: string; const OnSuccess: TProc = nil);
    procedure HandleHttpResponse(const AReq: TJSXMLHttpRequest;
      const SuccessMsg: string; const OnSuccess: TProc = nil;
      _showSuccesToast: Boolean = true);
    function ExtractStatusCodeFromText(const AText: string): Integer;
    procedure FixTabClasses;
    procedure ApplyTheme(const ATheme: string);
    procedure ToggleBodyClass(const AEnable: Boolean; const AClass: string);

    // demande vacance
    procedure InitDemandeFormHTML;
    procedure InitDemandeJSCallbacks;
    procedure SetPeriodeType(const APeriode: string);
    procedure ShowDemandeForm;
    procedure HideDemandeForm;
    procedure FetchMotifs;
    procedure HandleFetchMotifsResponse(const AResponse: string);
    procedure PopulateMotifsCombo;
    procedure FetchDemandesVacances;
    procedure HandleFetchDemandesResponse(const AResponse: string);
    function RenderDemandesList(const Demandes: TJSArray): string;
    function GetDecisionIcon(ADecision: JSValue): string;
    procedure ValidateAndPostDemande;
    procedure PostDemande(const ADateDebut, ADateFin, APeriode: string;
      AMotifId: Integer; const AHeureDebut, AHeureFin: string);
    procedure FetchHeuresParJour;
    procedure UpdateHeuresFromPeriode;
    procedure DeleteDemandeVacances(ADemandeID: Integer);

    // parametre pause automatique
    procedure FetchParametreMasquePause;
  public
    { Public API }
    // The form is used as the application shell; no public methods are required.

  protected procedure LoadDFMValues; override; end;

var
  Form_Main: TForm_Main;

implementation

{$R *.dfm}

uses U_DatetimeHelper, StrUtils, WebScannerForm, U_ParseHelper;

procedure TForm_Main.ShowSessionLoader;
begin
  WebPageControl_Main.Visible := False;
  asm
    if (!document.getElementById('session-loader')) {
    var loader = document.createElement('div');
    loader.id = 'session-loader';
    loader.style.cssText = 'display:flex;justify-content:center;align-items:center;height:80vh;color:var(--text);font-size:1.2rem;';
    loader.innerHTML = '<div style="text-align:center">' +
    '<span class="material-symbols-rounded" style="font-size:40px;animation:spin 1s linear infinite">sync</span>' +
    '<br>Chargement...</div>';
    document.body.appendChild(loader);
     }
  end;
end;

procedure TForm_Main.RemoveSessionLoader;
begin
  asm
    var el = document.getElementById('session-loader');
    if (el) el.remove();
  end;
  WebPageControl_Main.Visible := true;
end;

procedure TForm_Main.WebButton1Click(Sender: TObject);
begin
  // Otherwise, create it dynamically:
  if not Assigned(frmScanner) then
    Application.CreateForm(TfrmScanner, frmScanner);

  frmScanner.ShowModal(
    procedure(ModalResult: TModalResult)
    begin
      if ModalResult = mrOk then
      begin
        edtUsername.Text := Format('%s (%s)', [frmScanner.LastScanValue,
          frmScanner.LastFormat]);
        // TODO: handle the value (e.g., look up item by EAN/QR payload)
      end;
      // else
    end);
end;

procedure TForm_Main.WebButton_Correction_ValiderClick(Sender: TObject);
begin
  PostFinPresenceCorrectionRest(WebDateTimePicker_CorrectionHeure.Time);
end;

procedure TForm_Main.WebButton_DarkLightClick(Sender: TObject);
begin
  // Flip the theme; again, no JS touching FTheme.
  if FTheme = 'dark' then
    ApplyTheme('light')
  else
    ApplyTheme('dark');
end;

procedure TForm_Main.WebFormCreate(Sender: TObject);
var
  PortStr: String;
  Saved, Initial: string;
  PrefersDark: Boolean;
begin
  // Hide page control until session check completes
  WebPageControl_Main.Visible := False;

  WebButton_DarkLight.Visible := true;
  WebButton_DarkLight.ElementClassName := 'logout-button';

  Saved := '';
  if Assigned(LocalStorage1) then
    Saved := LocalStorage1.GetValue('theme');
  if Saved <> '' then
    ApplyTheme(Saved)
  else
  begin
    PrefersDark := False;
    asm
      if (window.matchMedia) {
      var m = window.matchMedia('(prefers-color-scheme: dark)');
      PrefersDark = !!m.matches;
       }
    end;
    ApplyTheme(IfThen(PrefersDark, 'dark', 'light'));
  end;

  if window.location.port <> '' then
    PortStr := ':' + window.location.port
  else
    PortStr := '';

  if window.location.hostname = 'localhost' then
    BaseApiUrl := 'http://localhost:8080/api'
  else
    BaseApiUrl := window.location.protocol + '//' +
      window.location.host + '/api';

  if not Assigned(FApi) then
    FApi := TApiClient.Create(Self, BaseApiUrl)
  else
    FApi.BaseUrl := BaseApiUrl;

  FApi.OnUnauthorized := procedure
    begin
      RessourceActive := nil;
      PresenceActive := nil;
      PauseActive := nil;
      ClearActiveRessourceFromStorage;
      ClearFields(true);
      ShowLoginPanel;
    end;

  FApi.OnNetworkError := procedure(Msg: string)
    begin
      showToast('Erreur réseau: ' + Msg, 'error');
    end;

  divTileContainer.ElementClassName := 'tile-container';
  lblPresence.HTML :=
    '<span class="material-symbols-rounded" style="vertical-align: middle; font-size: 20px; margin-right: 6px; color: var(--text);">timer</span>'
    + '<span style="vertical-align: middle; color: var(--text);">DOP Time</span>';
  lbl_identifiant.HTML :=
    '<span style="color: var(--text);">Identifiant</span>';

  asm
    window.addEventListener('orientationchange', function() {
    if (document.activeElement && document.activeElement.tagName === 'INPUT') {
    document.activeElement.blur();
     }
    });
  end;

  ShowSessionLoader;
  CheckSessionAndShowUI;
  DefineOnStartPresence;
  FixTabClasses;
end;

procedure TForm_Main.CheckSessionAndShowUI;
begin
  FApi.Get('/me',
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      FetchParametreMasquePause; // ← ajouter ici
      RestoreRessourceAfterReload;
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      ShowLoginPanel;
    end);
end;

procedure TForm_Main.WebTabSheet_RecapitulatifShow(Sender: TObject);
begin
  FetchRessourceStats;
end;

procedure TForm_Main.DefineOnStartPresence;
begin
  asm
    window.onStartPresence = () => {
    pas.U_Main.Form_Main.OnStartPresenceHandler();
     };
    window.onEndPresence = () => {
    pas.U_Main.Form_Main.OnEndPresenceHandler();
     };
    window.onStartPause = () => {
    pas.U_Main.Form_Main.OnStartPauseHandler();
     };
    window.onEndPause = () => {
    pas.U_Main.Form_Main.OnEndPauseHandler();
     };
  end;
end;

procedure TForm_Main.edtUsernameKeyDown(Sender: TObject; var Key: Word;
Shift: TShiftState);
begin
  if Key = 13 then // 13 = Enter key
  begin
    btnLogin.Click;
    Key := 0; // Optionally prevent default browser action (like form submission)
  end;
end;

procedure TForm_Main.OnStartPresenceHandler;
begin
  PostDebutPresenceRest(False);
end;

procedure TForm_Main.OnEndPresenceHandler;
begin
  PostFinPresenceRest(False);
end;

procedure TForm_Main.OnStartPauseHandler;
begin
  PostDebutPresenceRest(true);
end;

procedure TForm_Main.OnEndPauseHandler;
begin
  PostFinPresenceRest(true);
end;

procedure TForm_Main.GetRessourceInfo;
var
  Token: string;
begin
  // // or IsTokenExpired(Token)
  // then
  // // No token → get one first
  // AuthenticateAndThenFetchRessource(
  //
  //
  // AuthenticateAndThenFetchRessource(

  // Token exists → make the API call
  FetchRessourceInfo();
end;

procedure TForm_Main.DoLogin;
var
  J: TJSONObject;
  body: string;
  LCode: string;
begin
  // Code personnel entered by the user (adapt to your UI control)
  LCode := Trim(edtUsername.Text);

  if LCode = '' then
  begin
    ShowMessage('Please enter your code personnel');
    Exit;
  end;

  ShowSessionLoader; // <-- affiche le loader

  // Login: server sets an HttpOnly cookie. We never store the JWT in the browser.
  J := TJSONObject.Create;
  try
    J.AddPair('code', LCode);
    body := J.ToJSON;
  finally
    J.Free;
  end;

  FApi.PostJSON('/login/badge', body,
    procedure(const RespBody: string; Req: TJSXMLHttpRequest)
    begin
      ProcessLoginSuccess(RespBody);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      ShowLoginError;
    end);
end;

procedure TForm_Main.FetchRessourceInfo();
var
  Path: string;
begin
  Path := Format('/ressources?q=eq(code_personnel,"%s")', [edtUsername.Text]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchRessourceInfoResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      ShowLoginError;
    end);
end;

Procedure TForm_Main.addWithCredentials(var _httpGet: THttpRequest);
begin
  _httpGet.WithCredentials := true;
end;

procedure TForm_Main.HandleFetchRessourceInfoResponse(AResponse: string);
var
  tmpRessource: TRessource;
begin
  tmpRessource := ParseRessourceFromJSON(AResponse);
  if Assigned(tmpRessource) then
  begin
    RessourceActive := tmpRessource;
    SaveActiveRessourceToStorage;
    FetchActivePresenceForRessource(tmpRessource.id);
    showToast('Connexion réussie.');
  end
  else
    ShowLoginError;
end;

procedure TForm_Main.FetchActivePresenceForRessource(const _ressourceId
  : Integer);
var
  Path: string;
begin
  ClearFields(true);
  Path := Format('/ressources/%d/presence_active', [_ressourceId]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchActivePresenceForRessourceResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      if Req.Status = 401 then
        ShowLoginPanel
      else
        showToast(Format('Erreur %d: %s', [Req.Status, Msg]), 'error');
    end);
end;

procedure TForm_Main.HandleFetchActivePresenceForRessourceResponse
  (AResponse: string);
var
  PresencesArray: TJSArray;
  I: Integer;
  Obj: TJSObject;
  Presence: TPresence;
  needCorrection: Boolean;
  corrDT: TDateTime;
  corrTypeLib: string;
begin
  PresencesArray := ParsePresencesFromJSON(AResponse);

  for I := 0 to PresencesArray.length - 1 do
  begin
    Obj := TJSObject(PresencesArray[I]);
    Presence := CreatePresenceFromObject(Obj);
    if Presence.AffectationId = PRESENCE_AFF_ID then
      PresenceActive := Presence
    else if Presence.AffectationId = PAUSE_AFF_ID then
      PauseActive := Presence;
  end;
  btnLogout.Caption :=
    '<span class="material-symbols-rounded" style="vertical-align: middle; font-size: 16px; margin-right: 4px;">logout</span>'
    + leftstr(RessourceActive.Nom + ' ' + RessourceActive.Prenom, 15);

  needCorrection := False;

  // Cas 1 : pr\xe9sence ouverte d'un jour ant\xe9rieur
  if Assigned(PresenceActive) and (PresenceActive.DateSaisie <> Date) then
  begin
    corrDT := PresenceActive.DateSaisie + PresenceActive.HeureDebut;
    corrTypeLib := 'Pr\xe9sence';
    needCorrection := true;
  end
  // Cas 2 : pause ouverte d'un jour ant\xe9rieur (aucune pr\xe9sence ouverte car la pause a ferm\xe9 la pr\xe9sence)
  else if Assigned(PauseActive) and (PauseActive.DateSaisie <> Date) then
  begin
    corrDT := PauseActive.DateSaisie + PauseActive.HeureDebut;
    corrTypeLib := 'Pause';
    needCorrection := true;
  end;

  if needCorrection then
  begin
    WebLabel_Correction_DateHeure.Caption := corrTypeLib + ' ouverte le ' +
      FormatDateTime('dd.mm.yyyy "à" hh:nn', corrDT);
    ShowCorrectionPanel;
  end
  else
    ShowMainMenu;
end;

//
// HandleHttpResponseTextBased(AResponse, 'Connexion réussie',
// var
// else

// var
// // Default to 200 (assume OK unless error found)
//
// // Split the response into lines
//
// // Look for a line like 'HTTP 401: ...'
// // Example line: 'HTTP 401: Username and password required'
//
// else
// else if StatusCode = 401 then
// 'Non autorisé (401): Identifiant / mot-de-passe incorrect.'
// else

procedure TForm_Main.FetchParametreMasquePause;
begin
  FMasquePause := False; // défaut = afficher

  FApi.Get('/parametres/24',
    procedure(const body: string; Req: TJSXMLHttpRequest)
    var
      Data: TJSObject;
      Items: TJSArray;
      Item: TJSObject;
    begin
      Data := TJSJSON.parseObject(body);
      if Assigned(Data) and JS.isArray(Data['data']) then
      begin
        Items := TJSArray(Data['data']);
        if Items.length > 0 then
        begin
          Item := TJSObject(Items[0]);
          FMasquePause := (string(Item['valeur']) = '1');
        end;
      end;
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      // paramètre inexistant ou erreur → on affiche les boutons (défaut)
      FMasquePause := False;
    end);
end;

procedure TForm_Main.HandleHttpError(Sender: TObject;
ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
begin
  HandleHttpResponse(ARequest.Req, // just forward the inner request
  'Connexion réussie', // not really used on error, but required
  nil // no success callback
    );
  Handled := true;
end;

procedure TForm_Main.FetchSaisiePresenceTodayForRessource(RessourceID: Integer);
var
  Path: string;
begin
  Path := Format('/ressources/%d/presences_today', [RessourceID]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchSaisiePresenceTodayResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      // keep current UI, just show error
      showToast('Erreur lors du chargement des timbrages du jour', 'error');
    end);
end;

procedure TForm_Main.HandleFetchSaisiePresenceTodayResponse(AResponse: string);
begin
  // Alias for older code paths
  HandleFetchSaisiePresenceTodayForRessourceResponse(AResponse);
end;

procedure TForm_Main.HandleFetchSaisiePresenceTodayForRessourceResponse
  (AResponse: string);
var
  JSON: string;
  Data: TJSObject;
  Entries: TJSArray;
begin
  JSON := AResponse; // your JSON string from REST call
  Data := TJSJSON.parseObject(JSON);
  Entries := TJSArray(Data['data']);
  divTimbrages.HTML.Text := RenderTimbrages(Entries);
end;

procedure TForm_Main.FetchSaisiePresenceForDayAndRessource(_date: TDate;
RessourceID: Integer);
var
  strDate: string;
  Path: string;
begin
  strDate := FormatDateTime('yyyy-mm-dd', _date);
  Path := Format('/ressources/%d/presences?date=%s', [RessourceID, strDate]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchSaisiePresenceForDayResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors du chargement des timbrages', 'error');
    end);
end;

procedure TForm_Main.HandleFetchSaisiePresenceForDayResponse(AResponse: string);
begin
  // Alias for older code paths
  HandleFetchSaisiePresenceForDateAndRessourceResponse(AResponse);
end;

procedure TForm_Main.HandleFetchSaisiePresenceForDateAndRessourceResponse
  (AResponse: string);
var
  JSON: string;
  Data: TJSObject;
  Entries: TJSArray;
begin
  JSON := AResponse; // your JSON string from REST call
  Data := TJSJSON.parseObject(JSON);
  Entries := TJSArray(Data['data']);
  divTimbragesCorrection.HTML.Text := RenderTimbrages(Entries);
end;

procedure TForm_Main.btnLoginClick(Sender: TObject);
begin
  DoLogin;
end;

procedure TForm_Main.btnLogoutClick(Sender: TObject);
begin
  // Server clears the auth cookie. Then we cleanup local UI state.
  FApi.PostJSON('/logout', '{}',
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      RessourceActive := nil;
      PresenceActive := nil;
      PauseActive := nil;
      ClearActiveRessourceFromStorage;
      ClearFields(true);
      ShowLoginPanel;
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      // Even if logout fails, ensure local UI is cleaned.
      RessourceActive := nil;
      PresenceActive := nil;
      PauseActive := nil;
      ClearActiveRessourceFromStorage;
      ClearFields(true);
      ShowLoginPanel;
    end);
end;

procedure TForm_Main.ClearFields(_onlyPresence: Boolean);
begin
  if not _onlyPresence then
    if Assigned(RessourceActive) then
      freeandnil(RessourceActive);
  if Assigned(PresenceActive) then
    freeandnil(PresenceActive);
  if Assigned(PauseActive) then
    freeandnil(PauseActive);
end;

procedure TForm_Main.ShowLoginPanel;
begin
  btnLogout.Visible := False;
  WebPageControl_Main.ShowTabs := False;
  WebPageControl_Main.TabIndex := WebPageControl_Main_Identification.PageIndex;
  RemoveSessionLoader;
  edtUsername.SetFocus;
end;

procedure TForm_Main.ShowMainMenu;
var
  hasPresence, hasPause: Boolean;
begin
  btnLogout.Visible := true;
  WebPageControl_Main.ShowTabs := true;
  WebPageControl_Main.TabIndex := WebPageControl_Main_Presence.PageIndex;
  if Assigned(RessourceActive) and (RessourceActive.id > 0) then
  begin
    FetchSaisiePresenceTodayForRessource(RessourceActive.id);
    hasPresence := ((Assigned(PresenceActive)) and (PresenceActive.id > 0));
    hasPause := ((Assigned(PauseActive)) and (PauseActive.id > 0));

    // '<span class="material-symbols-rounded" style="vertical-align: middle; font-size: 16px; margin-right: 4px;">logout</span>'
    if not hasPresence and not hasPause then
    begin
      // aucune presence et aucune pause, tout inactif, sauf debut presence
      divPresenceDebutBtn.HTML.Text :=
        '<div class="presence-button active" onclick="onStartPresence()">' +
        '<div class="icon"><span class="material-symbols-rounded">login</span></div>'
        + '<div class="label">Présence</div>' + '<div class="sub">Début :</div>'
        + '</div>'; // GRAY, disabled
      divPresenceFinBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon"><span class="material-symbols-rounded">logout</span></div>'
        + '<div class="label">Présence</div>' + '<div class="sub">Fin</div>'
        + '</div>';
      divPauseDebutBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Début</div>'
        + '</div>';
      divPauseFinBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon crossed"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Fin</div>'
        + '</div>';
    end
    else if hasPresence and not hasPause then
    begin
      // si une presence active masi pas de pause, actif = fin presence, debut pause
      divPresenceDebutBtn.HTML.Text := '<div class="presence-button inactive">'
        + '<div class="icon"><span class="material-symbols-rounded">logout</span></div>'
        + '<div class="label">Présence</div>' +
        '<div class="sub">Début : <strong>' + FormatDateTime('hh:nn',
        PresenceActive.HeureDebut) + '</strong></div>' + '</div>';
      // RED, clickable
      divPresenceFinBtn.HTML.Text :=
        '<div class="presence-button fin-active" onclick="onEndPresence()">' +
        '<div class="icon"><span class="material-symbols-rounded">logout</span></div>'
        + '<div class="label">Présence</div>' + '<div class="sub">Fin :</div>'
        + '</div>';
      divPauseDebutBtn.HTML.Text :=
        '<div class="presence-button active" onclick="onStartPause()">' +
        '<div class="icon"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Début :</div>'
        + '</div>';
      divPauseFinBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon crossed"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Fin</div>'
        + '</div>';
    end
    else if (not hasPresence) and (hasPause) then
    begin
      divPresenceDebutBtn.HTML.Text := '<div class="presence-button inactive">'
        + '<div class="icon"><span class="material-symbols-rounded">logout</span></div>'
        + '<div class="label">Présence</div>' +
        '<div class="sub">Début : <strong>'
      // +
      // FormatDateTime('hh:nn',
      // PresenceActive.HeureDebut)
        + '</strong></div>' + '</div>';

      divPresenceFinBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon"><span class="material-symbols-rounded">logout</span></div>'
        + '<div class="label">Présence</div>' + '<div class="sub">Fin</div>'
        + '</div>';
      // Green, clickable
      divPauseDebutBtn.HTML.Text := '<div class="presence-button inactive">' +
        '<div class="icon"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Début : <strong>'
        + FormatDateTime('hh:nn', PauseActive.HeureDebut) + '</strong></div>'
        + '</div>';
      divPauseFinBtn.HTML.Text :=
        '<div class="presence-button fin-active" onclick="onEndPause()">' +
        '<div class="icon crossed"><span class="material-symbols-rounded">free_breakfast</span></div>'
        + '<div class="label">Pause</div>' + '<div class="sub">Fin :</div>'
        + '</div>';
    end;
  end;
  // Rendre l'onglet Demandes visible et actif dans les tabs
  WebPageControl_Main_DemandeVac.TabVisible := true;
  WebPageControl_Main_DemandeVac.TabEnabled := true;
  WebPageControl_Main_DemandeVac.Visible := true;

  // Masquer les boutons pause si paramètre activé
  divPauseDebutBtn.Visible := not FMasquePause;
  divPauseFinBtn.Visible := not FMasquePause;

  if FMasquePause then
    divTileContainer.Height := 140
  else
    divTileContainer.Height := 262;

  RemoveSessionLoader;
end;

procedure TForm_Main.ShowCorrectionPanel;
var
  dateRef: TDate;
begin
  btnLogout.Caption :=
    '<span class="material-symbols-rounded" style="vertical-align: middle; font-size: 16px; margin-right: 4px;">logout</span>'
    + leftstr(RessourceActive.Nom + ' ' + RessourceActive.Prenom, 15);
  btnLogout.Visible := true;

  // On prend la date de l'enregistrement ouvert : pr\xe9sence en priorit\xe9, sinon pause
  if Assigned(PresenceActive) then
    dateRef := PresenceActive.DateSaisie
  else if Assigned(PauseActive) then
    dateRef := PauseActive.DateSaisie
  else
  begin
    // Cas improbable : plus rien d'ouvert, on renvoie au menu
    ShowMainMenu;
    Exit;
  end;

  FetchSaisiePresenceForDayAndRessource(dateRef, RessourceActive.id);
  WebPageControl_Main.TabIndex := WebPageControl_Main_Correction.PageIndex;
  RemoveSessionLoader;
end;

procedure TForm_Main.HandleSecureResponse(Sender: TObject; AResponse: string);
begin
  ShowMessage('Secure API Response: ' + AResponse);
end;

procedure TForm_Main.HandleSecureError(Sender: TObject; AMessage: string);
begin
  ShowMessage('Secure request failed: ' + AMessage);
end;

function TForm_Main.ParseRessourceFromJSON(const AJSON: string): TRessource;
var
  JSONObject: TJSObject;
  DataArrayVal: JSValue;
  DataArray: TJSArray;
  FirstItem: TJSObject;
begin
  result := nil;
  JSONObject := TJSJSON.parseObject(AJSON);

  if Assigned(JSONObject) then
  begin
    DataArrayVal := JSONObject['data'];

    // Check if it's an array and cast safely
    if JS.isArray(DataArrayVal) then
    begin
      DataArray := TJSArray(DataArrayVal);
      if DataArray.length > 0 then
      begin
        DataArrayVal := DataArray[0];
        FirstItem := TJSObject(DataArray[0]);
        result := TRessource.Create;
        result.id := StrToIntDef(string(FirstItem['ID']), 0);
        result.Nom := string(FirstItem['NOM']);
        result.Prenom := string(FirstItem['PRENOM']);
        result.SysDate := string(FirstItem['SYSDATE']);
        result.SysUtil := string(FirstItem['SYSUTIL']);
        result.SysPoste := string(FirstItem['SYSPOSTE']);
        result.Num := StrToIntDef(string(FirstItem['NUM']), 0);
        result.Humaine := StrToIntDef(string(FirstItem['HUMAINE']), 0);
        result.CodePersonnel := string(FirstItem['CODEPERSONNEL']);
      end;
    end;
  end;
end;

function TForm_Main.ParsePresencesFromJSON(const AJSON: string): TJSArray;
var
  JSONObject: TJSObject;
  DataArrayVal: JSValue;
  DataArray: TJSArray;
begin
  result := TJSArray.new;
  // Always return an array, even if empty

  JSONObject := TJSJSON.parseObject(AJSON);
  if Assigned(JSONObject) then
  begin
    DataArrayVal := JSONObject['data'];

    if JS.isArray(DataArrayVal) then
    begin
      DataArray := TJSArray(DataArrayVal);

      // Optionally: loop over DataArray to log or process each item
      if DataArray.length = 0 then
      begin
        Console.Log('No presences found.');
      end
      else
      begin
        Console.Log('Found ' + DataArray.length.toString + ' presences.');
      end;

      result := DataArray; // Return the raw array (can parse later per item)
    end
    else
    begin
      Console.Log('No "data" array found in JSON.');
    end;
  end
  else
    Console.Log('Invalid JSON');
end;

function TForm_Main.CreatePresenceFromObject(const Obj: TJSObject): TPresence;
begin
  result := TPresence.Create;
  result.id := StrToIntDef(string(Obj['id']), 0);
  result.RessourceID := StrToIntDef(string(Obj['ressourceid']), 0);
  result.TypeSaisieId := StrToIntDef(string(Obj['typesaisieid']), 0);
  result.AffectationId := StrToIntDef(string(Obj['affectationid']), 0);

  result.DateSaisie := SafeISO8601ToDate(string(Obj['debut']));
  result.DateFin := SafeISO8601ToDate(string(Obj['fin']));

  result.HeureDebut := SafeISO8601ToTime(string(Obj['heuredebut']));
  result.HeureFin := SafeISO8601ToTime(string(Obj['heurefin']));
end;

function TForm_Main.RenderTimbrages(const Timbrages: TJSArray): string;
var
  I: Integer;
  Item: TJSObject;
  HTML, aDate, Debut, Fin, TypeStr: string;
begin
  // Format today's date
  aDate := FormatDateTime('dd.mm.yyyy', now);

  HTML := '<div class="timbrage-header">' +
    '<div class="title">Timbrages du jour</div>' + '<div class="date">' + aDate
    + '</div>' + '  </div>';

  // Loop through each entry
  for I := 0 to Timbrages.length - 1 do
  begin
    Item := TJSObject(Timbrages[I]);

    // Detect type from affectationid
    if Item['affectationid'] = PRESENCE_AFF_ID then
      TypeStr := 'Présence'
    else if Item['affectationid'] = PAUSE_AFF_ID then
      TypeStr := 'Pause'
    else
      Continue;

    // Get values safely
    aDate := Copy(string(Item['debut']), 9, 2) + '.' +
      Copy(string(Item['debut']), 6, 2) + '.' +
      Copy(string(Item['debut']), 1, 4);

    Debut := Copy(string(Item['heuredebut']), 1, 5);
    Fin := string(Item['heurefin']);
    if ((Fin <> '') and (Fin <> 'null')) then
      Fin := Copy(Fin, 1, 5)
    else
      Fin := '–';

    // Append HTML block
    HTML := HTML + '<div class="timbrage-entry">' +
      '<button class="icon-button" data-id="' + string(Item['id']) + '">' +
      '<span class="material-symbols-rounded">badge</span>' + '</button>' +
      '<div class="info">' + '<div class="label">' + TypeStr + '</div>' +
      '<div class="detail">Date : ' + aDate + ' &nbsp;&nbsp; Début : ' + Debut +
      ' &nbsp;&nbsp; Fin : ' + Fin + '</div>' + '</div>' + '</div>';
  end;

  // Assign HTML to container
  result := HTML;
end;

Procedure TForm_Main.RenderStatsFromJSON(const AJSON: string);
var
  ParsedValue: JSValue;
  DataArray: TJSArray;
  FirstItem: TJSObject;
  Valeur: string;
begin
  WebHTMLDiv_RecapTitre.HTML.Text := '<div class="timbrage-header">' +
    '<div class="title">Récapitulatif</div></div>';

  // Parse JSON (returns JSValue)
  ParsedValue := TJSJSON.parse(AJSON);

  // Check and cast to array
  if not JS.isArray(ParsedValue) then
    Exit;

  DataArray := TJSArray(ParsedValue);
  if DataArray.length = 0 then
    Exit;

  FirstItem := TJSObject(DataArray[0]);

  // solde jour
  if Assigned(FirstItem['out_h_jour_solde']) then
    Valeur := string(FirstItem['out_h_jour_solde'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapSoldeDuJour.HTML.Text :=
    getDivForStatField('Solde Tps', Valeur);

  if Assigned(FirstItem['out_h_semaine_prevue']) then
    Valeur := string(FirstItem['out_h_semaine_prevue'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapSemainePrevu.HTML.Text :=
    getDivForStatField('Semaine prévu', Valeur);

  if Assigned(FirstItem['out_h_semaine_realisee']) then
    Valeur := string(FirstItem['out_h_semaine_realisee'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapSemaineRealise.HTML.Text :=
    getDivForStatField('Semaine réalisé', Valeur);

  if Assigned(FirstItem['out_h_semaine_solde']) then
    Valeur := string(FirstItem['out_h_semaine_solde'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapSemaineSolde.HTML.Text :=
    getDivForStatField('Semaine solde', Valeur);

  if Assigned(FirstItem['out_h_mois_solde']) then
    Valeur := string(FirstItem['out_h_mois_solde'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapMoisEncours.HTML.Text :=
    getDivForStatField('Mois solde', Valeur);

  if Assigned(FirstItem['out_h_annee_solde']) then
    Valeur := string(FirstItem['out_h_annee_solde'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapAnneeEnCours.HTML.Text :=
    getDivForStatField('Année solde', Valeur);

  // vacances
  WebHTMLDiv_RecapTitreVacance.HTML.Text := '<div class="timbrage-header">' +
    '<div class="title">Vacances en jours</div></div>';

  if Assigned(FirstItem['out_vac_annuelle_string']) then
    Valeur := string(FirstItem['out_vac_annuelle_string'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapVacanceConvenu.HTML.Text :=
    getDivForStatField('Convenu', Valeur);
  if Assigned(FirstItem['out_vac_reste_prece_string']) then
    Valeur := string(FirstItem['out_vac_reste_prece_string'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapVacanceSoldeMois1.HTML.Text :=
    getDivForStatField('Solde année préc.', Valeur);
  if Assigned(FirstItem['out_vac_real_planif_string']) then
    Valeur := string(FirstItem['out_vac_real_planif_string'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapVacanceRealisePlanifie.HTML.Text :=
    getDivForStatField('Réalisées + planifiées', Valeur);
  if Assigned(FirstItem['out_vac_solde_string']) then
    Valeur := string(FirstItem['out_vac_solde_string'])
  else
    Valeur := 'N/A';
  WebHTMLDiv_RecapVacanceSoldeDispo.HTML.Text :=
    getDivForStatField('Solde vacances dispo.', Valeur);
end;

Function TForm_Main.getDivForStatField(_titre, _valeur: string): String;
var
  FloatVal: Double;
  FormattedVal: string;
begin
  if _valeur = 'N/A' then
    _valeur := '0.00';
  // Normalize decimal separator
  _valeur := StringReplace(_valeur, ',', '.', [rfReplaceAll]);

  try
    FloatVal := JS.parseFloat(_valeur);
    if not JS.jsIsNaN(FloatVal) then
      FormattedVal := FormatFloat('0.00', FloatVal)
    else
      FormattedVal := '–';
  except
    FormattedVal := '–';
  end;

  result := '<div class="recap-line">' + '<span class="recap-caption">' + _titre
    + '</span>' + '<span class="recap-value">' + FormattedVal + '</span>'
    + '</div>';
end;

procedure TForm_Main.ShowLoginError;
begin
  RemoveSessionLoader; // sinon on reste bloqué
  asm
    Swal.fire({
    icon: 'error',
    title: 'Identifiant incorrect',
    text: 'Vérifier votre identifiant',
    confirmButtonText: 'Ok'
     });
  end;
end;

procedure TForm_Main.showToast(const Msg: string;
const ToastType: string = 'success');
begin
  asm
    if (typeof toastr !== 'undefined') {
    toastr.options.timeOut = 3000;
    toastr.options.extendedTimeOut = 1000;
    toastr.options.positionClass = 'toast-top-center'; // still needed for init
    toastr.clear(); // Clear previous toasts

    switch (ToastType) {
    case 'success': toastr.success(Msg); break;
    case 'error': toastr.error(Msg); break;
    case 'info': toastr.info(Msg); break;
    case 'warning': toastr.warning(Msg); break;
    default: toastr.info(Msg); break;
     }

    } else {
    alert(Msg); // Fallback
     }
  end;
end;

procedure TForm_Main.PostDebutPresenceRest(_pause: Boolean);
var
  Presence: TJSONObject;
  body: string;
  msgSuccess: string;
  Path: string;
begin
  if not Assigned(RessourceActive) then
    Exit;

  Presence := TJSONObject.Create;
  try
    Presence.AddPair('id', '0');
    Presence.AddPair('sysdate', FormatDateTime('yyyy-mm-dd"T"hh:nn:ss', now));
    Presence.AddPair('sysutil', IntToStr(RessourceActive.id));
    Presence.AddPair('sysposte', 'DOPG TIME WEB');
    if not _pause then
      Presence.AddPair('affectationid', IntToStr(PRESENCE_AFF_ID))
    else
      Presence.AddPair('affectationid', IntToStr(PAUSE_AFF_ID));

    Presence.AddPair('ressourceid', IntToStr(RessourceActive.id));
    Presence.AddPair('debut', FormatDateTime('yyyy-mm-dd', Date));
    Presence.AddPair('heuredebut', FormatDateTime('hh:nn:ss', Time));

    body := Presence.toString;
  finally
    Presence.Free;
  end;

  Path := Format('/ressources/%d/presences', [RessourceActive.id]);

  msgSuccess := 'Début de présence enregistré';
  if _pause then
    msgSuccess := 'Début de pause enregistré';

  FApi.PostJSON(Path, body,
    procedure(const Resp: string; Req: TJSXMLHttpRequest)
    begin
      HandleHttpResponse(Req, msgSuccess,
        procedure
        begin
          FetchActivePresenceForRessource(RessourceActive.id);
        end, False);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors de l''enregistrement', 'error');
    end);
end;

procedure TForm_Main.PostFinPresenceRest(_pause: Boolean);
var
  Presence: TJSONObject;
  body: string;
  msgSuccess: string;
  tmpId: Integer;
  Path: string;
begin
  if not Assigned(RessourceActive) then
    Exit;

  if not _pause then
  begin
    if not Assigned(PresenceActive) then
      Exit;
    tmpId := PresenceActive.id;
  end
  else
  begin
    if not Assigned(PauseActive) then
      Exit;
    tmpId := PauseActive.id;
  end;

  Presence := TJSONObject.Create;
  try
    Presence.AddPair('fin', FormatDateTime('yyyy-mm-dd', Date));
    Presence.AddPair('heurefin', FormatDateTime('hh:nn:ss', Time));
    body := Presence.toString; // ✅ FIX
  finally
    Presence.Free;
  end;

  Path := Format('/ressources/%d/presences/%d', [RessourceActive.id, tmpId]);

  msgSuccess := 'Fin de présence enregistrée.';
  if _pause then
    msgSuccess := 'Fin de pause enregistrée.';

  FApi.PutJSON(Path, body,
    procedure(const Resp: string; Req: TJSXMLHttpRequest)
    begin
      HandleHttpResponse(Req, msgSuccess,
        procedure
        begin
          FetchActivePresenceForRessource(RessourceActive.id);
        end, False);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors de l''enregistrement', 'error');
    end);
end;

procedure TForm_Main.PostFinPresenceCorrectionRest(_heureFin: ttime);
var
  J: TJSONObject;
  body, Path, msgSuccess: string;
  tmpId: Integer;
  target: TPresence;
begin
  if not Assigned(RessourceActive) then
    Exit;

  // Priorit\xe9 : la pr\xe9sence si elle est ouverte, sinon la pause
  if Assigned(PresenceActive) then
  begin
    target := PresenceActive;
    msgSuccess := 'Fin de pr\xe9sence enregistr\xe9e.';
  end
  else if Assigned(PauseActive) then
  begin
    target := PauseActive;
    msgSuccess := 'Fin de pause enregistr\xe9e.';
  end
  else
    Exit;

  tmpId := target.id;

  J := TJSONObject.Create;
  try
    J.AddPair('fin', FormatDateTime('yyyy-mm-dd', target.DateSaisie));
    J.AddPair('heurefin', FormatDateTime('hh:nn:ss', _heureFin));
    body := J.toString;
  finally
    J.Free;
  end;

  Path := Format('/ressources/%d/presences/%d', [RessourceActive.id, tmpId]);

  FApi.PutJSON(Path, body,
    procedure(const Resp: string; Req: TJSXMLHttpRequest)
    begin
      HandleHttpResponse(Req, msgSuccess,
        procedure
        begin
          FetchActivePresenceForRessource(RessourceActive.id);
        end, False);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors de la correction', 'error');
    end);
end;

procedure TForm_Main.FetchRessourceStats();
var
  Path: string;
begin
  if not Assigned(RessourceActive) then
    Exit;

  Path := Format('/ressources/%d/stats', [RessourceActive.id]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      RenderStatsFromJSON(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors du chargement des statistiques', 'error');
    end);
end;

procedure TForm_Main.HandleHttpResponse(const AReq: TJSXMLHttpRequest;
const SuccessMsg: string; const OnSuccess: TProc = nil;
_showSuccesToast: Boolean = true);
var
  StatusMsg: string;
  IsSuccess: Boolean;
begin
  IsSuccess := true;

  // 0:
  // 200, 201, 202, 204:
  // // 201:
  // // 202:
  // // 204:
  //
  // 400:
  // 401:
  // 403:
  // 404:
  // 409:
  // 422:
  //
  // 500 .. 599:
  // else

  THttpParse.StatusFromResponse(AReq, SuccessMsg, IsSuccess, StatusMsg);

  if IsSuccess then
  begin
    if _showSuccesToast then
      showToast(StatusMsg);
    if Assigned(OnSuccess) then
      OnSuccess();
  end
  else
    showToast(StatusMsg, 'error');
end;

procedure TForm_Main.ProcessLoginSuccess(const AResponse: string);
begin
  // With HttpOnly cookie auth, the JWT is NOT in the response.

  // Optionally you can parse AResponse if you want to show username/roles,
  // because your API returns: {"status":"authenticated","username":"...","roles":[...],"expiresIn":...}

  FetchRessourceInfo();
end;

procedure TForm_Main.HandleHttpResponseTextBased(const AResponse: string;
const SuccessMsg: string; const OnSuccess: TProc = nil);
var
  StatusCode: Integer;
  StatusMsg: string;
begin
  StatusCode := ExtractStatusCodeFromText(AResponse);

  case StatusCode of
    200:
      StatusMsg := SuccessMsg;
    400:
      StatusMsg := 'Requête invalide.';
    401:
      StatusMsg := 'Non autorisé. Identifiant / mot-de-passe incorrect.';
    403:
      StatusMsg := 'Accès interdit.';
    404:
      StatusMsg := 'Service introuvable.';
    422:
      StatusMsg := 'Erreur de validation.';
    500 .. 599:
      StatusMsg := 'Erreur serveur (' + IntToStr(StatusCode) + ').';
  else
    StatusMsg := 'Erreur HTTP inconnue: ' + IntToStr(StatusCode);
  end;

  if StatusCode = 200 then
  begin
    showToast(StatusMsg);
    if Assigned(OnSuccess) then
      OnSuccess();
  end
  else
    showToast(StatusMsg, 'error');
end;

function TForm_Main.ExtractStatusCodeFromText(const AText: string): Integer;
var
  Line: string;
  Lines: TArray<string>;
begin
  result := 200; // default OK
  Lines := AText.Split([sLineBreak, #13, #10],
    TStringSplitOptions.ExcludeEmpty);

  for Line in Lines do
  begin
    if Line.StartsWith('HTTP ') then
    begin
      result := StrToIntDef(Copy(Line, 6, 3), 500); // extract 3-digit code
      Exit;
    end;
  end;
end;

procedure TForm_Main.FixTabClasses;
begin
  asm
    var ul = document.getElementById("TForm_Main_PageControl1_UL");
    if (ul && !ul.classList.contains('custom-tabs')) {
    ul.classList.add('nav-tabs');
     }
  end;
end;

procedure TForm_Main.ToggleBodyClass(const AEnable: Boolean;
const AClass: string);
begin
  // No references to FTheme here; just use the boolean you pass in.
  asm
    document.body.classList.toggle(AClass, AEnable);
  end;
end;

procedure TForm_Main.ApplyTheme(const ATheme: string);
var
  IsDark: Boolean;
begin
  FTheme := ATheme.ToLower;
  IsDark := FTheme = 'dark';

  ToggleBodyClass(IsDark, 'theme-dark');

  // Update button caption (optional)
  if IsDark then
    WebButton_DarkLight.Caption := '☀'
  else
    WebButton_DarkLight.Caption := '🌙';

  // Persist choice (safe even if LocalStorage1 is not on form)
  if Assigned(LocalStorage1) then
    LocalStorage1.SetValue('theme', FTheme);
end;

{ ------------------------------------------------------------------------------ }
{ localStorage helpers - keep current ressource across page reloads (no JWT) }
{ ------------------------------------------------------------------------------ }

procedure TForm_Main.SaveActiveRessourceToStorage;
begin
  if not Assigned(RessourceActive) then
    Exit;

  window.localStorage.setItem(LS_RESSOURCE_ID, IntToStr(RessourceActive.id));
  window.localStorage.setItem(LS_RESSOURCE_CODE, RessourceActive.CodePersonnel);
end;

procedure TForm_Main.ClearActiveRessourceFromStorage;
begin
  window.localStorage.removeItem(LS_RESSOURCE_ID);
  window.localStorage.removeItem(LS_RESSOURCE_CODE);
end;

function TForm_Main.LoadStoredRessourceId: Integer;
var
  S: string;
begin
  result := 0;
  S := window.localStorage.getItem(LS_RESSOURCE_ID);
  if S <> '' then
    result := StrToIntDef(S, 0);
end;

function TForm_Main.LoadStoredRessourceCode: string;
begin
  result := window.localStorage.getItem(LS_RESSOURCE_CODE);
end;

procedure TForm_Main.RestoreRessourceAfterReload;
var
  Code: string;
begin
  // After a page reload, in-memory objects are lost. We rebuild RessourceActive
  // from a safe identifier stored in localStorage (code_personnel).
  Code := LoadStoredRessourceCode;

  if ((Code = '') OR (Code = null)) then
  begin
    ShowLoginPanel;
    Exit;
  end;

  edtUsername.Text := Code;
  FetchRessourceInfo; // will set RessourceActive and continue flow
end;

{ ============================================================================ }
{ DEMANDES VACANCES }
{ ============================================================================ }

procedure TForm_Main.WebTabSheet_DemandeVacShow(Sender: TObject);
begin
  InitDemandeFormHTML;
  HideDemandeForm;

  // Enregistrer le callback global pour le bouton "+" de la liste
  asm
    window.showDemandeForm = function() {
    pas.U_Main.Form_Main.ShowDemandeForm();
     };
  end;

  if not Assigned(FMotifs) or (FMotifs.length = 0) then
    FetchMotifs;

  FetchDemandesVacances;
end;

procedure TForm_Main.InitDemandeFormHTML;
begin
  FPeriodeSelectionnee := 'journee';

  divDemandeForm.HTML.Text := '<div class="demande-form-inner">' +

  // 1. Période
    '<div class="demande-row">' + '<div class="periode-btn-group">' +
    '<button class="periode-btn active" data-periode="journee">Journ'#233'e</button>'
    + '<button class="periode-btn" data-periode="matin">Matin</button>' +
    '<button class="periode-btn" data-periode="apresmidi">Apr'#232's-midi</button>'
    + '<button class="periode-btn" data-periode="libre">Libre</button>' +
    '</div>' + '</div>' +

  // 2. Dates
    '<div class="demande-row">' + '<div class="demande-col">' +
    '<label class="demande-label">Date d'#233'but</label>' +
    '<input type="date" id="edtDateDebut" class="form-control responsive-input">'
    + '</div>' + '<div class="demande-col">' +
    '<label class="demande-label">Date fin</label>' +
    '<input type="date" id="edtDateFin" class="form-control responsive-input">'
    + '</div>' + '</div>' +

  // 3. Heures (masquées sauf "libre")
    '<div class="demande-row demande-heures" id="divHeuresRow" style="display:none;">'
    + '<div class="demande-col">' +
    '<label class="demande-label">Heure d'#233'but</label>' +
    '<input type="time" id="edtHeureDebut" class="form-control responsive-input" value="08:00">'
    + '</div>' + '<div class="demande-col">' +
    '<label class="demande-label">Heure fin</label>' +
    '<input type="time" id="edtHeureFin" class="form-control responsive-input" value="17:00">'
    + '</div>' + '</div>' +

  // 4. Motif
    '<div class="demande-row">' + '<label class="demande-label">Motif</label>' +
    '<select id="cboMotifSelect" class="form-control responsive-input">' +
    '<option value="">-- S'#233'lectionner --</option>' + '</select>' +
    '</div>' +

  // 5. Boutons
    '<div class="demande-row demande-buttons">' +
    '<button class="btn btn-primary" id="btnEnvoyer">Envoyer la demande</button>'
    + '<button class="btn btn-secondary" id="btnAnnuler">Annuler</button>' +
    '</div>' +

    '</div>';

  // Set default dates
  asm
    var today = new Date().toISOString().substring(0, 10);
    var el1 = document.getElementById('edtDateDebut');
    var el2 = document.getElementById('edtDateFin');
    if (el1) el1.value = today;
    if (el2) el2.value = today;
  end;
end;

procedure TForm_Main.InitDemandeJSCallbacks;
begin
  asm
    // Period buttons
    document.querySelectorAll('.periode-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
    var p = this.getAttribute('data-periode');
    pas.U_Main.Form_Main.SetPeriodeType(p);
     });
    });

    // Date début → ajuster date fin si nécessaire + recalculer heures
    var dtDebut = document.getElementById('edtDateDebut');
    if (dtDebut) dtDebut.addEventListener('change', function() {
    var dtFin = document.getElementById('edtDateFin');
    if (dtFin && this.value > dtFin.value) {
    dtFin.value = this.value;
     }
    pas.U_Main.Form_Main.FetchHeuresParJour();
    });

    // Motif change → recalculer heures
    var selMotif = document.getElementById('cboMotifSelect');
    if (selMotif) selMotif.addEventListener('change', function() {
    pas.U_Main.Form_Main.FetchHeuresParJour();
     });

    // Envoyer
    var btnE = document.getElementById('btnEnvoyer');
    if (btnE) btnE.addEventListener('click', function() {
    pas.U_Main.Form_Main.ValidateAndPostDemande();
     });

    // Annuler
    var btnA = document.getElementById('btnAnnuler');
    if (btnA) btnA.addEventListener('click', function() {
    pas.U_Main.Form_Main.HideDemandeForm();
     });

    // FAB button
    window.showDemandeForm = (function() {
    pas.U_Main.Form_Main.ShowDemandeForm();
     });
  end; end;

  procedure TForm_Main.SetPeriodeType(
  const
APeriode:
  string); begin FPeriodeSelectionnee := APeriode;

  asm
    // Toggle active class on buttons
    document.querySelectorAll('.periode-btn').forEach(function(b) {
    b.classList.toggle('active', b.getAttribute('data-periode') === APeriode);
     });

    var hDebut = document.getElementById('edtHeureDebut');
    var hFin   = document.getElementById('edtHeureFin');
    var hRow   = document.getElementById('divHeuresRow');
    if (!hDebut || !hFin || !hRow) return;

    if (APeriode === 'libre') {
    hRow.style.display = '';
    hDebut.value = '08:00';
    hFin.value   = '17:00';
     } else {
    hRow.style.display = 'none';
     }
  end; end;

  procedure TForm_Main.ShowDemandeForm; begin divDemandeForm.Visible := true;
  InitDemandeJSCallbacks; PopulateMotifsCombo;

  // Masquer le bouton "+"
  asm
    var fab = document.querySelector('.btn-fab');
    if (fab) fab.style.display = 'none';
  end;

  // Reset to today
  asm
    var today = new Date().toISOString().substring(0, 10);
    var el1 = document.getElementById('edtDateDebut');
    var el2 = document.getElementById('edtDateFin');
    if (el1) el1.value = today;
    if (el2) el2.value = today;
    var sel = document.getElementById('cboMotifSelect');
    if (sel) sel.selectedIndex = 0;
  end;

  SetPeriodeType('journee'); end;

  procedure TForm_Main.HideDemandeForm; begin divDemandeForm.Visible := False;

  // Réafficher le bouton "+"
  asm
    var fab = document.querySelector('.btn-fab');
    if (fab) fab.style.display = '';
  end; end;

  { --- Motifs --- }

  procedure TForm_Main.FetchMotifs; var Path: string;
  begin if not Assigned(RessourceActive) then Exit; Path := '/motifs_absence';

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchMotifsResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors du chargement des motifs', 'error');
    end); end;

  procedure TForm_Main.HandleFetchMotifsResponse(
  const
  AResponse:
    string); var ParsedValue: JSValue; Data: TJSObject;
  begin ParsedValue := TJSJSON.parse(AResponse);

  // Render(Q) renvoie un tableau direct [...]
  // OU un objet {"data": [...]} selon la config DMV
  if JS.isArray(ParsedValue) then FMotifs := TJSArray(ParsedValue)
  else begin Data := TJSObject(ParsedValue);
  if Assigned(Data) and JS.isArray(Data['data']) then FMotifs :=
    TJSArray(Data['data']) else FMotifs := TJSArray.new; end;

  PopulateMotifsCombo; end;

  procedure TForm_Main.PopulateMotifsCombo; begin
  asm
    var sel = document.getElementById('cboMotifSelect');
    if (!sel) return;

    // Clear all except first option
    while (sel.options.length > 1) sel.remove(1);

    var motifs = this.FMotifs;
    if (motifs) {
    for (var i = 0; i < motifs.length; i++) {
    var item = motifs[i];
    var opt = document.createElement('option');
    // Firebird renvoie en MAJUSCULES, on gère les deux cas
    opt.value = String(item['ID'] || item['id'] || '');
    opt.textContent = String(item['LIBELLE'] || item['libelle'] || '');
    sel.appendChild(opt);
     }
    }
  end; end;

  { --- Liste demandes --- }

  procedure TForm_Main.FetchDemandesVacances; var Path: string;
  begin if not Assigned(RessourceActive) then Exit;

  Path := Format('/ressources/%d/demandes_vacances', [RessourceActive.id]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      HandleFetchDemandesResponse(body);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors du chargement des demandes', 'error');
    end); end;

  procedure TForm_Main.HandleFetchDemandesResponse(
  const
  AResponse:
    string); var Data: TJSObject; Items: TJSArray;
  begin Data := TJSJSON.parseObject(AResponse);
  if Assigned(Data) and JS.isArray(Data['data']) then Items :=
    TJSArray(Data['data']) else Items := TJSArray.new;

  divDemandesList.HTML.Text := RenderDemandesList(Items);
  // Attacher les événements click sur les boutons supprimer
  asm
    window.deleteDemandeVacances = function(id) {
    pas.U_Main.Form_Main.DeleteDemandeVacances(id);
     };

    setTimeout(function() {
    document.querySelectorAll('.btn-delete-demande').forEach(function(btn) {
    btn.addEventListener('click', function() {
    var id = parseInt(this.getAttribute('data-id'), 10);
    Swal.fire({
    title: 'Supprimer cette demande ?',
    text: 'Cette action est irréversible.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Supprimer',
    cancelButtonText: 'Annuler',
    confirmButtonColor: '#c62828'
     }).then(function(result) {
    if (result.isConfirmed) {
    window.deleteDemandeVacances(id);
     }
    });
    });
    });
    }, 100);
  end; end;

  function TForm_Main.GetDecisionIcon(ADecision: JSValue): string;
  begin if JS.isNull(ADecision) or JS.isUndefined(ADecision) then
  // Pas encore traité → en attente
    result := '<span class="material-symbols-rounded" style="color:#888;font-size:20px;">schedule</span>'
  else if Integer(ADecision) = 1 then
  // Validé
    result := '<span class="material-symbols-rounded" style="color:#2e7d32;font-size:20px;">check_circle</span>'
  else
  // Refusé (0 ou autre valeur)
    result := '<span class="material-symbols-rounded" style="color:#c62828;font-size:20px;">close</span>';
  end;

  function TForm_Main.RenderDemandesList(const Demandes: TJSArray): string;
  var I: Integer; Item: TJSObject; HTML, DateDeb, DateFin, Motif, HeureD,
    HeureF, DecisionHTML, DetailStr, PeriodeLabel: string; Periode: Integer;
  begin HTML := '<div class="timbrage-header">' +
    '<div class="title">Mes demandes</div>' + '<div class="date">' +
    '<button class="btn-fab" onclick="showDemandeForm()">+</button>' + '</div>'
    + '</div>';

  if Demandes.length = 0 then begin HTML := HTML +
    '<div style="text-align:center;color:var(--border);padding:40px 0;">' +
    '<span class="material-symbols-rounded" style="font-size:48px;opacity:0.3;">event_busy</span>'
    + '<br>Aucune demande</div>'; result := HTML; Exit; end;

  for I := 0 to Demandes.length - 1 do begin Item := TJSObject(Demandes[I]);

  // Dates
  DateDeb := Copy(string(Item['datedebut']), 9,
    2) + '.' + Copy(string(Item['datedebut']), 6,
    2) + '.' + Copy(string(Item['datedebut']), 1, 4);
  DateFin := Copy(string(Item['datefin']), 9,
    2) + '.' + Copy(string(Item['datefin']), 6,
    2) + '.' + Copy(string(Item['datefin']), 1, 4);

  // Motif
  Motif := string(Item['motiflibelle']); if (Motif = '') or (Motif = 'undefined')
  then Motif := string(Item['motifcode']);
  if (Motif = '') or (Motif = 'undefined') then Motif := 'Sans motif';

  // Période (1=journée, 2=matin, 3=apresmidi, 4=libre)
  Periode := StrToIntDef(string(Item['periode']), 1);

  // Heures — extraire HH:MM depuis la valeur ISO
  HeureD := string(Item['heuredebut']); HeureF := string(Item['heurefin']);
  asm
  function extractHHMM(s) {
    if (!s || s === 'null' || s === 'undefined') return '';
    var tIdx = s.indexOf('T');
    if (tIdx >= 0) return s.substring(tIdx + 1, tIdx + 6);
    if (s.length >= 5 && s.indexOf(':') > 0) return s.substring(0, 5);
    return '';
     }
    HeureD = extractHHMM(HeureD);
    HeureF = extractHHMM(HeureF);
  end;

  // Decision
  DecisionHTML := GetDecisionIcon(Item['traitement']);

  // Construire la ligne de détail selon la période
  case Periode of 1: PeriodeLabel := 'Journ'#233'e'; 2: PeriodeLabel := 'Matin';
  3: PeriodeLabel := 'Apr'#232's-midi'; else PeriodeLabel := ''; end;

  if Periode = 4 then begin
  // Libre → afficher les heures réelles
  if DateDeb = DateFin then DetailStr := DateDeb + ' de ' + HeureD + ' '#224' '
    + HeureF else DetailStr := DateDeb + ' ' + HeureD + ' '#8594' ' + DateFin +
    ' ' + HeureF; end else begin
  // Journée/Matin/Aprèsmidi → afficher le type de période
  if DateDeb = DateFin then DetailStr := DateDeb + ' (' + PeriodeLabel +
    ')' else DetailStr := DateDeb + ' '#8594' ' + DateFin + ' (' + PeriodeLabel
    + ')'; end;

  HTML := HTML + '<div class="timbrage-entry">' +
    '<div style="margin-right:12px;">' + DecisionHTML + '</div>' +
    '<div class="info" style="flex:1;">' + '<div class="label">' + Motif +
    '</div>' + '<div class="detail">' + DetailStr + '</div>' + '</div>';

  // Bouton supprimer uniquement si pas encore traitée
  if JS.isNull(Item['traitement']) or JS.isUndefined(Item['traitement'])
  then HTML := HTML + '<button class="icon-button btn-delete-demande" ' +
    'data-id="' + string(Item['id']) + '" ' +
    'style="margin-left:8px;background:none;border:none;cursor:pointer;" ' +
    'title="Supprimer">' +
    '<span class="material-symbols-rounded" style="color:#c62828;font-size:22px;">delete</span>'
    + '</button>';

  HTML := HTML + '</div>'; end;

  result := HTML; end;

  { --- Validation + POST --- }

  { --- Heures par jour (API) --- }

  procedure TForm_Main.FetchHeuresParJour;
  var Path, MotifIdStr, DateStr: string;
  begin if not Assigned(RessourceActive) then Exit;

  asm
    var sel = document.getElementById('cboMotifSelect');
    MotifIdStr = sel ? sel.value : '';
    DateStr = document.getElementById('edtDateDebut').value || '';
  end;

  if (MotifIdStr = '') or (MotifIdStr = '0') then Exit;
  if DateStr = '' then Exit;

  Path := Format('/ressources/%d/heures_par_jour?motif_id=%s&date=%s',
    [RessourceActive.id, MotifIdStr, DateStr]);

  FApi.Get(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    var
      Data: TJSObject;
    begin
      Data := TJSJSON.parseObject(body);
      if Assigned(Data) then
        FHeuresParJour := Double(Data['heures_par_jour'])
      else
        FHeuresParJour := 8.0;
      UpdateHeuresFromPeriode;
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      FHeuresParJour := 8.0;
      UpdateHeuresFromPeriode;
    end); end;

  procedure TForm_Main.UpdateHeuresFromPeriode; var demiH, fullH: Double;
  begin if FHeuresParJour <= 0 then FHeuresParJour := 8.0;

  demiH := FHeuresParJour / 2.0; fullH := FHeuresParJour;

  asm
  function addHours(startH, startM, hours) {
    var totalMin = startH * 60 + startM + Math.round(hours * 60);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
     }

    var hDebut = document.getElementById('edtHeureDebut');
    var hFin   = document.getElementById('edtHeureFin');
    if (!hDebut || !hFin) return;

    var periode = this.FPeriodeSelectionnee;
    switch (periode) {
    case 'journee':
    hDebut.value = '08:00';
    hFin.value   = addHours(8, 0, fullH);
    break;
    case 'matin':
    hDebut.value = '08:00';
    hFin.value   = addHours(8, 0, demiH);
    break;
    case 'apresmidi':
    hDebut.value = '13:00';
    hFin.value   = addHours(13, 0, demiH);
    break;
     }
  end; end;

  { --- Validation + POST --- }

  procedure TForm_Main.ValidateAndPostDemande;
  var DateDebut, DateFin, HeureDebut, HeureFin, MotifIdStr: string;
  MotifId: Integer; begin
  // Read values from DOM
  asm
    DateDebut = document.getElementById('edtDateDebut').value || '';
    DateFin = document.getElementById('edtDateFin').value || '';
    HeureDebut = document.getElementById('edtHeureDebut').value || '';
    HeureFin = document.getElementById('edtHeureFin').value || '';
    var sel = document.getElementById('cboMotifSelect');
    MotifIdStr = sel ? sel.value : '';
  end;

  // Validate
  if DateDebut = '' then begin showToast('Veuillez saisir une date de début.',
    'warning'); Exit; end;

  if DateFin = '' then begin showToast('Veuillez saisir une date de fin.',
    'warning'); Exit; end;

  if DateFin < DateDebut then begin showToast
    ('La date de fin doit être postérieure à la date de début.', 'warning');
  Exit; end;

  // Vérifier que la date de début n'est pas trop ancienne (> 365 jours)
  asm
    var minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    var dbDate = new Date(DateDebut);
    if (dbDate < minDate) {
    pas.U_Main.Form_Main.showToast(
    'La date de début ne peut pas être antérieure à un an.', 'warning');
    return;
     }
  end;

  MotifId := StrToIntDef(MotifIdStr, 0);
  if MotifId = 0 then begin showToast('Veuillez sélectionner un motif.',
    'warning'); Exit; end;

  if (FPeriodeSelectionnee = 'libre') and ((HeureDebut = '') or (HeureFin = ''))
  then begin showToast('Veuillez saisir les heures de début et fin.',
    'warning'); Exit; end;

  if (FPeriodeSelectionnee = 'libre') and (HeureFin <= HeureDebut)
  then begin showToast('L''heure de fin doit être après l''heure de début.',
    'warning'); Exit; end;

  // All good — send
  PostDemande(DateDebut, DateFin, FPeriodeSelectionnee, MotifId, HeureDebut,
    HeureFin); end;

  procedure TForm_Main.PostDemande(const ADateDebut, ADateFin, APeriode: string;
    AMotifId: Integer; const AHeureDebut, AHeureFin: string);
  var J: TJSONObject; body, Path, msgSuccess: string;
  begin if not Assigned(RessourceActive) then Exit;

  J := TJSONObject.Create; try J.AddPair('ressourceid',
    IntToStr(RessourceActive.id)); J.AddPair('date_debut', ADateDebut);
  J.AddPair('date_fin', ADateFin); J.AddPair('motif_id', IntToStr(AMotifId));
  J.AddPair('periode', APeriode);

  if APeriode = 'libre' then begin J.AddPair('heure_debut',
    AHeureDebut + ':00'); J.AddPair('heure_fin', AHeureFin + ':00');
  end else if APeriode = 'matin' then begin J.AddPair('heure_debut',
    '08:00:00'); J.AddPair('heure_fin', '12:00:00');
  end else if APeriode = 'apresmidi' then begin J.AddPair('heure_debut',
    '13:00:00'); J.AddPair('heure_fin', '17:00:00'); end;

  body := J.toString; finally J.Free; end;

  Path := Format('/ressources/%d/demandes_vacances', [RessourceActive.id]);
  msgSuccess := 'Demande envoyée avec succès.';

  FApi.PostJSON(Path, body,
    procedure(const Resp: string; Req: TJSXMLHttpRequest)
    begin
      HandleHttpResponse(Req, msgSuccess,
        procedure
        begin
          HideDemandeForm;
          FetchDemandesVacances;
        end);
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Erreur lors de l''envoi de la demande', 'error');
    end); end;

  procedure TForm_Main.DeleteDemandeVacances(ADemandeID: Integer);
  var Path: string; begin if not Assigned(RessourceActive) then Exit;

  Path := Format('/ressources/%d/demandes_vacances/%d', [RessourceActive.id,
    ADemandeID]);

  FApi.Delete(Path,
    procedure(const body: string; Req: TJSXMLHttpRequest)
    begin
      showToast('Demande supprimée.');
      FetchDemandesVacances;
    end,
    procedure(const Msg: string; Req: TJSXMLHttpRequest)
    begin
      if Req.Status = 409 then
        showToast('Impossible de supprimer une demande déjà traitée.', 'error')
      else if Req.Status = 404 then
        showToast('Demande introuvable.', 'error')
      else
        showToast('Erreur lors de la suppression.', 'error');
    end); end; procedure TForm_Main.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPageControl_Main := TPageControl.Create('WebHTMLDiv_RecapTitre');
  WebPageControl_Main_Identification := TTabSheet.Create(Self);
  WebHTMLDiv2 := THTMLDiv.Create(Self);
  WebHTMLDiv3 := THTMLDiv.Create(Self);
  lbl_identifiant := TLabel.Create(Self);
  edtUsername := TEdit.Create(Self);
  WebButton1 := TButton.Create(Self);
  btnLogin := TButton.Create(Self);
  WebPageControl_Main_Presence := TTabSheet.Create(Self);
  WebHTMLDiv1 := THTMLDiv.Create(Self);
  divTileContainer := THTMLDiv.Create(Self);
  divPresenceDebutBtn := THTMLDiv.Create(Self);
  divPresenceFinBtn := THTMLDiv.Create(Self);
  divPauseDebutBtn := THTMLDiv.Create(Self);
  divPauseFinBtn := THTMLDiv.Create(Self);
  divTimbrages := THTMLDiv.Create(Self);
  WebTabSheet_Recapitulatif := TTabSheet.Create(Self);
  WebHTMLDiv4 := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapTitre := THTMLDiv.Create('WebHTMLDiv_RecapTitre');
  WebHTMLDiv_RecapSoldeDuJour := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapSemainePrevu := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapSemaineRealise := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapSemaineSolde := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapMoisEncours := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapAnneeEnCours := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapTitreVacance := THTMLDiv.Create('WebHTMLDiv_RecapTitre');
  WebHTMLDiv_RecapVacanceConvenu := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapVacanceSoldeMois1 := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapVacanceRealisePlanifie := THTMLDiv.Create(Self);
  WebHTMLDiv_RecapVacanceSoldeDispo := THTMLDiv.Create(Self);
  WebHTMLDiv5 := THTMLDiv.Create(Self);
  WebHTMLDiv6 := THTMLDiv.Create(Self);
  WebPageControl_Main_Correction := TTabSheet.Create(Self);
  WebHTMLDiv8 := THTMLDiv.Create(Self);
  WebHTMLDiv_Correction_Top := THTMLDiv.Create(Self);
  WebHTMLDiv9 := THTMLDiv.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel_Correction_DateHeure := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebButton_Correction_Valider := TButton.Create(Self);
  WebDateTimePicker_CorrectionHeure := TDateTimePicker.Create(Self);
  divTimbragesCorrection := THTMLDiv.Create(Self);
  WebPageControl_Main_DemandeVac := TTabSheet.Create(Self);
  divDemandeVacContainer := THTMLDiv.Create(Self);
  divDemandeForm := THTMLDiv.Create(Self);
  divDemandesList := THTMLDiv.Create(Self);
  WebHTMLDiv_EntetePresence := THTMLDiv.Create(Self);
  lblPresence := TLabel.Create(Self);
  WebHTMLDiv7 := THTMLDiv.Create(Self);
  btnLogout := TButton.Create(Self);
  WebButton_DarkLight := TButton.Create(Self);
  LocalStorage1 := TLocalStorage.Create(Self);

  WebPageControl_Main.BeforeLoadDFMValues;
  WebPageControl_Main_Identification.BeforeLoadDFMValues;
  WebHTMLDiv2.BeforeLoadDFMValues;
  WebHTMLDiv3.BeforeLoadDFMValues;
  lbl_identifiant.BeforeLoadDFMValues;
  edtUsername.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  WebPageControl_Main_Presence.BeforeLoadDFMValues;
  WebHTMLDiv1.BeforeLoadDFMValues;
  divTileContainer.BeforeLoadDFMValues;
  divPresenceDebutBtn.BeforeLoadDFMValues;
  divPresenceFinBtn.BeforeLoadDFMValues;
  divPauseDebutBtn.BeforeLoadDFMValues;
  divPauseFinBtn.BeforeLoadDFMValues;
  divTimbrages.BeforeLoadDFMValues;
  WebTabSheet_Recapitulatif.BeforeLoadDFMValues;
  WebHTMLDiv4.BeforeLoadDFMValues;
  WebHTMLDiv_RecapTitre.BeforeLoadDFMValues;
  WebHTMLDiv_RecapSoldeDuJour.BeforeLoadDFMValues;
  WebHTMLDiv_RecapSemainePrevu.BeforeLoadDFMValues;
  WebHTMLDiv_RecapSemaineRealise.BeforeLoadDFMValues;
  WebHTMLDiv_RecapSemaineSolde.BeforeLoadDFMValues;
  WebHTMLDiv_RecapMoisEncours.BeforeLoadDFMValues;
  WebHTMLDiv_RecapAnneeEnCours.BeforeLoadDFMValues;
  WebHTMLDiv_RecapTitreVacance.BeforeLoadDFMValues;
  WebHTMLDiv_RecapVacanceConvenu.BeforeLoadDFMValues;
  WebHTMLDiv_RecapVacanceSoldeMois1.BeforeLoadDFMValues;
  WebHTMLDiv_RecapVacanceRealisePlanifie.BeforeLoadDFMValues;
  WebHTMLDiv_RecapVacanceSoldeDispo.BeforeLoadDFMValues;
  WebHTMLDiv5.BeforeLoadDFMValues;
  WebHTMLDiv6.BeforeLoadDFMValues;
  WebPageControl_Main_Correction.BeforeLoadDFMValues;
  WebHTMLDiv8.BeforeLoadDFMValues;
  WebHTMLDiv_Correction_Top.BeforeLoadDFMValues;
  WebHTMLDiv9.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel_Correction_DateHeure.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebButton_Correction_Valider.BeforeLoadDFMValues;
  WebDateTimePicker_CorrectionHeure.BeforeLoadDFMValues;
  divTimbragesCorrection.BeforeLoadDFMValues;
  WebPageControl_Main_DemandeVac.BeforeLoadDFMValues;
  divDemandeVacContainer.BeforeLoadDFMValues;
  divDemandeForm.BeforeLoadDFMValues;
  divDemandesList.BeforeLoadDFMValues;
  WebHTMLDiv_EntetePresence.BeforeLoadDFMValues;
  lblPresence.BeforeLoadDFMValues;
  WebHTMLDiv7.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  WebButton_DarkLight.BeforeLoadDFMValues;
  LocalStorage1.BeforeLoadDFMValues;
  try
    Name := 'Form_Main';
    Width := 487;
    Height := 636;
    Align := alClient;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPageControl_Main.SetParentComponent(Self);
    WebPageControl_Main.Name := 'WebPageControl_Main';
    WebPageControl_Main.Left := 0;
    WebPageControl_Main.Top := 50;
    WebPageControl_Main.Width := 487;
    WebPageControl_Main.Height := 586;
    WebPageControl_Main.Center.Horizontal := True;
    WebPageControl_Main.ElementClassName := 'custom-tabs';
    WebPageControl_Main.WidthStyle := ssPercent;
    WebPageControl_Main.Align := alClient;
    WebPageControl_Main.Anchors := [];
    WebPageControl_Main.ChildOrder := 1;
    WebPageControl_Main.TabIndex := 0;
    WebPageControl_Main.ShowTabs := False;
    WebPageControl_Main.TabOrder := 0;
    WebPageControl_Main.Visible := False;
    WebPageControl_Main_Identification.SetParentComponent(WebPageControl_Main);
    WebPageControl_Main_Identification.Name := 'WebPageControl_Main_Identification';
    WebPageControl_Main_Identification.Left := 0;
    WebPageControl_Main_Identification.Top := 20;
    WebPageControl_Main_Identification.Width := 487;
    WebPageControl_Main_Identification.Height := 566;
    WebPageControl_Main_Identification.Center.Horizontal := True;
    WebPageControl_Main_Identification.WidthStyle := ssPercent;
    WebPageControl_Main_Identification.Align := alClient;
    WebPageControl_Main_Identification.Anchors := [];
    WebPageControl_Main_Identification.BorderStyle := bsNone;
    WebPageControl_Main_Identification.Caption := 'Identification';
    WebPageControl_Main_Identification.TabVisible := False;
    WebHTMLDiv2.SetParentComponent(WebPageControl_Main_Identification);
    WebHTMLDiv2.Name := 'WebHTMLDiv2';
    WebHTMLDiv2.Left := 0;
    WebHTMLDiv2.Top := 0;
    WebHTMLDiv2.Width := 487;
    WebHTMLDiv2.Height := 566;
    WebHTMLDiv2.Center.Horizontal := True;
    WebHTMLDiv2.ElementClassName := 'page-container';
    WebHTMLDiv2.WidthStyle := ssPercent;
    WebHTMLDiv2.Align := alClient;
    WebHTMLDiv2.Anchors := [];
    WebHTMLDiv2.ChildOrder := 7;
    WebHTMLDiv2.ElementPosition := epRelative;
    WebHTMLDiv2.Role := '';
    WebHTMLDiv3.SetParentComponent(WebHTMLDiv2);
    WebHTMLDiv3.Name := 'WebHTMLDiv3';
    WebHTMLDiv3.Left := 87;
    WebHTMLDiv3.Top := 3;
    WebHTMLDiv3.Width := 312;
    WebHTMLDiv3.Height := 478;
    WebHTMLDiv3.Center.Horizontal := True;
    WebHTMLDiv3.ElementClassName := 'login-form-container';
    WebHTMLDiv3.HeightStyle := ssAuto;
    WebHTMLDiv3.Anchors := [];
    WebHTMLDiv3.ChildOrder := 5;
    WebHTMLDiv3.ElementPosition := epRelative;
    WebHTMLDiv3.Role := '';
    lbl_identifiant.SetParentComponent(WebHTMLDiv3);
    lbl_identifiant.Name := 'lbl_identifiant';
    lbl_identifiant.Left := 13;
    lbl_identifiant.Top := 177;
    lbl_identifiant.Width := 54;
    lbl_identifiant.Height := 15;
    lbl_identifiant.Caption := 'Identifiant';
    lbl_identifiant.ElementClassName := 'presence-label';
    lbl_identifiant.HeightPercent := 100.000000000000000000;
    lbl_identifiant.WidthPercent := 100.000000000000000000;
    edtUsername.SetParentComponent(WebHTMLDiv3);
    edtUsername.Name := 'edtUsername';
    edtUsername.Left := 11;
    edtUsername.Top := 203;
    edtUsername.Width := 280;
    edtUsername.Height := 22;
    edtUsername.ChildOrder := 2;
    edtUsername.ElementClassName := 'form-control mb-2 responsive-input';
    edtUsername.ElementFont := efCSS;
    edtUsername.Font.Charset := DEFAULT_CHARSET;
    edtUsername.Font.Color := clWindowText;
    edtUsername.Font.Height := -12;
    edtUsername.Font.Name := 'Segoe UI';
    edtUsername.Font.Style := [];
    edtUsername.HeightPercent := 100.000000000000000000;
    edtUsername.ParentFont := False;
    edtUsername.WidthPercent := 100.000000000000000000;
    SetEvent(edtUsername, Self, 'OnKeyDown', 'edtUsernameKeyDown');
    WebButton1.SetParentComponent(WebHTMLDiv3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 297;
    WebButton1.Top := 203;
    WebButton1.Width := 9;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 2;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    btnLogin.SetParentComponent(WebHTMLDiv3);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 95;
    btnLogin.Top := 245;
    btnLogin.Width := 121;
    btnLogin.Height := 49;
    btnLogin.Caption := 'Se connecter';
    btnLogin.Center.Horizontal := True;
    btnLogin.ChildOrder := 2;
    btnLogin.ElementClassName := 'btn btn-primary';
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    WebPageControl_Main_Presence.SetParentComponent(WebPageControl_Main);
    WebPageControl_Main_Presence.Name := 'WebPageControl_Main_Presence';
    WebPageControl_Main_Presence.Left := 0;
    WebPageControl_Main_Presence.Top := 20;
    WebPageControl_Main_Presence.Width := 487;
    WebPageControl_Main_Presence.Height := 566;
    WebPageControl_Main_Presence.Center.Horizontal := True;
    WebPageControl_Main_Presence.WidthStyle := ssPercent;
    WebPageControl_Main_Presence.Align := alClient;
    WebPageControl_Main_Presence.Anchors := [];
    WebPageControl_Main_Presence.BorderStyle := bsNone;
    WebPageControl_Main_Presence.Caption := 'Pr'#233'sence';
    WebPageControl_Main_Presence.ChildOrder := 1;
    WebHTMLDiv1.SetParentComponent(WebPageControl_Main_Presence);
    WebHTMLDiv1.Name := 'WebHTMLDiv1';
    WebHTMLDiv1.Left := 0;
    WebHTMLDiv1.Top := 0;
    WebHTMLDiv1.Width := 487;
    WebHTMLDiv1.Height := 566;
    WebHTMLDiv1.Center.Horizontal := True;
    WebHTMLDiv1.ElementClassName := 'page-container';
    WebHTMLDiv1.WidthStyle := ssPercent;
    WebHTMLDiv1.Align := alClient;
    WebHTMLDiv1.Anchors := [];
    WebHTMLDiv1.ChildOrder := 5;
    WebHTMLDiv1.ElementPosition := epRelative;
    WebHTMLDiv1.Role := '';
    divTileContainer.SetParentComponent(WebHTMLDiv1);
    divTileContainer.Name := 'divTileContainer';
    divTileContainer.Left := 0;
    divTileContainer.Top := 0;
    divTileContainer.Width := 487;
    divTileContainer.Height := 262;
    divTileContainer.Center.Horizontal := True;
    divTileContainer.ElementClassName := 'tile-container';
    divTileContainer.WidthStyle := ssPercent;
    divTileContainer.Align := alTop;
    divTileContainer.ChildOrder := 8;
    divTileContainer.ElementPosition := epRelative;
    divTileContainer.Role := '';
    divPresenceDebutBtn.SetParentComponent(divTileContainer);
    divPresenceDebutBtn.Name := 'divPresenceDebutBtn';
    divPresenceDebutBtn.Left := 27;
    divPresenceDebutBtn.Top := 3;
    divPresenceDebutBtn.Width := 114;
    divPresenceDebutBtn.Height := 127;
    divPresenceDebutBtn.HeightStyle := ssAuto;
    divPresenceDebutBtn.WidthStyle := ssAuto;
    divPresenceDebutBtn.ChildOrder := 8;
    divPresenceDebutBtn.ElementPosition := epRelative;
    divPresenceDebutBtn.ElementFont := efCSS;
    divPresenceDebutBtn.Role := '';
    divPresenceFinBtn.SetParentComponent(divTileContainer);
    divPresenceFinBtn.Name := 'divPresenceFinBtn';
    divPresenceFinBtn.Left := 174;
    divPresenceFinBtn.Top := 2;
    divPresenceFinBtn.Width := 107;
    divPresenceFinBtn.Height := 127;
    divPresenceFinBtn.HeightStyle := ssAuto;
    divPresenceFinBtn.WidthStyle := ssAuto;
    divPresenceFinBtn.ChildOrder := 8;
    divPresenceFinBtn.ElementPosition := epRelative;
    divPresenceFinBtn.ElementFont := efCSS;
    divPresenceFinBtn.Role := '';
    divPauseDebutBtn.SetParentComponent(divTileContainer);
    divPauseDebutBtn.Name := 'divPauseDebutBtn';
    divPauseDebutBtn.Left := 27;
    divPauseDebutBtn.Top := 136;
    divPauseDebutBtn.Width := 114;
    divPauseDebutBtn.Height := 106;
    divPauseDebutBtn.HeightStyle := ssAuto;
    divPauseDebutBtn.WidthStyle := ssAuto;
    divPauseDebutBtn.ChildOrder := 8;
    divPauseDebutBtn.ElementPosition := epRelative;
    divPauseDebutBtn.ElementFont := efCSS;
    divPauseDebutBtn.Role := '';
    divPauseFinBtn.SetParentComponent(divTileContainer);
    divPauseFinBtn.Name := 'divPauseFinBtn';
    divPauseFinBtn.Left := 174;
    divPauseFinBtn.Top := 136;
    divPauseFinBtn.Width := 107;
    divPauseFinBtn.Height := 106;
    divPauseFinBtn.HeightStyle := ssAuto;
    divPauseFinBtn.WidthStyle := ssAuto;
    divPauseFinBtn.ChildOrder := 8;
    divPauseFinBtn.ElementPosition := epRelative;
    divPauseFinBtn.ElementFont := efCSS;
    divPauseFinBtn.Role := '';
    divTimbrages.SetParentComponent(WebHTMLDiv1);
    divTimbrages.Name := 'divTimbrages';
    divTimbrages.Left := 0;
    divTimbrages.Top := 262;
    divTimbrages.Width := 487;
    divTimbrages.Height := 304;
    divTimbrages.ElementClassName := 'timbrage-section';
    divTimbrages.WidthStyle := ssPercent;
    divTimbrages.Align := alClient;
    divTimbrages.Anchors := [];
    divTimbrages.ChildOrder := 11;
    divTimbrages.ElementPosition := epRelative;
    divTimbrages.Role := '';
    WebTabSheet_Recapitulatif.SetParentComponent(WebPageControl_Main);
    WebTabSheet_Recapitulatif.Name := 'WebTabSheet_Recapitulatif';
    WebTabSheet_Recapitulatif.Left := 0;
    WebTabSheet_Recapitulatif.Top := 20;
    WebTabSheet_Recapitulatif.Width := 487;
    WebTabSheet_Recapitulatif.Height := 566;
    WebTabSheet_Recapitulatif.Center.Horizontal := True;
    WebTabSheet_Recapitulatif.ElementClassName := 'page-container';
    WebTabSheet_Recapitulatif.WidthStyle := ssPercent;
    WebTabSheet_Recapitulatif.Align := alClient;
    WebTabSheet_Recapitulatif.Anchors := [];
    WebTabSheet_Recapitulatif.BorderStyle := bsNone;
    WebTabSheet_Recapitulatif.Caption := 'R'#233'capitulatif';
    WebTabSheet_Recapitulatif.ChildOrder := 2;
    SetEvent(WebTabSheet_Recapitulatif, Self, 'OnShow', 'WebTabSheet_RecapitulatifShow');
    WebHTMLDiv4.SetParentComponent(WebTabSheet_Recapitulatif);
    WebHTMLDiv4.Name := 'WebHTMLDiv4';
    WebHTMLDiv4.Left := 47;
    WebHTMLDiv4.Top := 5;
    WebHTMLDiv4.Width := 393;
    WebHTMLDiv4.Height := 579;
    WebHTMLDiv4.Center.Horizontal := True;
    WebHTMLDiv4.ElementClassName := 'responsive-pagecontrol';
    WebHTMLDiv4.Anchors := [akTop];
    WebHTMLDiv4.ChildOrder := 12;
    WebHTMLDiv4.ElementPosition := epRelative;
    WebHTMLDiv4.Role := '';
    WebHTMLDiv_RecapTitre.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapTitre.Name := 'WebHTMLDiv_RecapTitre';
    WebHTMLDiv_RecapTitre.Left := 15;
    WebHTMLDiv_RecapTitre.Top := 35;
    WebHTMLDiv_RecapTitre.Width := 375;
    WebHTMLDiv_RecapTitre.Height := 28;
    WebHTMLDiv_RecapTitre.Anchors := [];
    WebHTMLDiv_RecapTitre.ChildOrder := 1;
    WebHTMLDiv_RecapTitre.ElementPosition := epRelative;
    WebHTMLDiv_RecapTitre.Role := '';
    WebHTMLDiv_RecapSoldeDuJour.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapSoldeDuJour.Name := 'WebHTMLDiv_RecapSoldeDuJour';
    WebHTMLDiv_RecapSoldeDuJour.Left := 15;
    WebHTMLDiv_RecapSoldeDuJour.Top := 62;
    WebHTMLDiv_RecapSoldeDuJour.Width := 375;
    WebHTMLDiv_RecapSoldeDuJour.Height := 28;
    WebHTMLDiv_RecapSoldeDuJour.Anchors := [];
    WebHTMLDiv_RecapSoldeDuJour.ChildOrder := 2;
    WebHTMLDiv_RecapSoldeDuJour.ElementPosition := epRelative;
    WebHTMLDiv_RecapSoldeDuJour.Role := '';
    WebHTMLDiv_RecapSemainePrevu.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapSemainePrevu.Name := 'WebHTMLDiv_RecapSemainePrevu';
    WebHTMLDiv_RecapSemainePrevu.Left := 15;
    WebHTMLDiv_RecapSemainePrevu.Top := 114;
    WebHTMLDiv_RecapSemainePrevu.Width := 375;
    WebHTMLDiv_RecapSemainePrevu.Height := 28;
    WebHTMLDiv_RecapSemainePrevu.Anchors := [];
    WebHTMLDiv_RecapSemainePrevu.ChildOrder := 3;
    WebHTMLDiv_RecapSemainePrevu.ElementPosition := epRelative;
    WebHTMLDiv_RecapSemainePrevu.Role := '';
    WebHTMLDiv_RecapSemaineRealise.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapSemaineRealise.Name := 'WebHTMLDiv_RecapSemaineRealise';
    WebHTMLDiv_RecapSemaineRealise.Left := 15;
    WebHTMLDiv_RecapSemaineRealise.Top := 141;
    WebHTMLDiv_RecapSemaineRealise.Width := 375;
    WebHTMLDiv_RecapSemaineRealise.Height := 28;
    WebHTMLDiv_RecapSemaineRealise.Anchors := [];
    WebHTMLDiv_RecapSemaineRealise.ChildOrder := 4;
    WebHTMLDiv_RecapSemaineRealise.ElementPosition := epRelative;
    WebHTMLDiv_RecapSemaineRealise.Role := '';
    WebHTMLDiv_RecapSemaineSolde.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapSemaineSolde.Name := 'WebHTMLDiv_RecapSemaineSolde';
    WebHTMLDiv_RecapSemaineSolde.Left := 15;
    WebHTMLDiv_RecapSemaineSolde.Top := 167;
    WebHTMLDiv_RecapSemaineSolde.Width := 375;
    WebHTMLDiv_RecapSemaineSolde.Height := 28;
    WebHTMLDiv_RecapSemaineSolde.Anchors := [];
    WebHTMLDiv_RecapSemaineSolde.ChildOrder := 5;
    WebHTMLDiv_RecapSemaineSolde.ElementPosition := epRelative;
    WebHTMLDiv_RecapSemaineSolde.Role := '';
    WebHTMLDiv_RecapMoisEncours.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapMoisEncours.Name := 'WebHTMLDiv_RecapMoisEncours';
    WebHTMLDiv_RecapMoisEncours.Left := 15;
    WebHTMLDiv_RecapMoisEncours.Top := 216;
    WebHTMLDiv_RecapMoisEncours.Width := 375;
    WebHTMLDiv_RecapMoisEncours.Height := 28;
    WebHTMLDiv_RecapMoisEncours.Anchors := [];
    WebHTMLDiv_RecapMoisEncours.ChildOrder := 6;
    WebHTMLDiv_RecapMoisEncours.ElementPosition := epRelative;
    WebHTMLDiv_RecapMoisEncours.Role := '';
    WebHTMLDiv_RecapAnneeEnCours.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapAnneeEnCours.Name := 'WebHTMLDiv_RecapAnneeEnCours';
    WebHTMLDiv_RecapAnneeEnCours.Left := 15;
    WebHTMLDiv_RecapAnneeEnCours.Top := 243;
    WebHTMLDiv_RecapAnneeEnCours.Width := 375;
    WebHTMLDiv_RecapAnneeEnCours.Height := 28;
    WebHTMLDiv_RecapAnneeEnCours.Anchors := [];
    WebHTMLDiv_RecapAnneeEnCours.ChildOrder := 7;
    WebHTMLDiv_RecapAnneeEnCours.ElementPosition := epRelative;
    WebHTMLDiv_RecapAnneeEnCours.Role := '';
    WebHTMLDiv_RecapTitreVacance.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapTitreVacance.Name := 'WebHTMLDiv_RecapTitreVacance';
    WebHTMLDiv_RecapTitreVacance.Left := 15;
    WebHTMLDiv_RecapTitreVacance.Top := 287;
    WebHTMLDiv_RecapTitreVacance.Width := 375;
    WebHTMLDiv_RecapTitreVacance.Height := 28;
    WebHTMLDiv_RecapTitreVacance.Anchors := [];
    WebHTMLDiv_RecapTitreVacance.ChildOrder := 9;
    WebHTMLDiv_RecapTitreVacance.ElementPosition := epRelative;
    WebHTMLDiv_RecapTitreVacance.Role := '';
    WebHTMLDiv_RecapVacanceConvenu.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapVacanceConvenu.Name := 'WebHTMLDiv_RecapVacanceConvenu';
    WebHTMLDiv_RecapVacanceConvenu.Left := 15;
    WebHTMLDiv_RecapVacanceConvenu.Top := 320;
    WebHTMLDiv_RecapVacanceConvenu.Width := 375;
    WebHTMLDiv_RecapVacanceConvenu.Height := 28;
    WebHTMLDiv_RecapVacanceConvenu.Anchors := [];
    WebHTMLDiv_RecapVacanceConvenu.ChildOrder := 10;
    WebHTMLDiv_RecapVacanceConvenu.ElementPosition := epRelative;
    WebHTMLDiv_RecapVacanceConvenu.Role := '';
    WebHTMLDiv_RecapVacanceSoldeMois1.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapVacanceSoldeMois1.Name := 'WebHTMLDiv_RecapVacanceSoldeMois1';
    WebHTMLDiv_RecapVacanceSoldeMois1.Left := 15;
    WebHTMLDiv_RecapVacanceSoldeMois1.Top := 347;
    WebHTMLDiv_RecapVacanceSoldeMois1.Width := 375;
    WebHTMLDiv_RecapVacanceSoldeMois1.Height := 28;
    WebHTMLDiv_RecapVacanceSoldeMois1.Anchors := [];
    WebHTMLDiv_RecapVacanceSoldeMois1.ChildOrder := 11;
    WebHTMLDiv_RecapVacanceSoldeMois1.ElementPosition := epRelative;
    WebHTMLDiv_RecapVacanceSoldeMois1.Role := '';
    WebHTMLDiv_RecapVacanceRealisePlanifie.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapVacanceRealisePlanifie.Name := 'WebHTMLDiv_RecapVacanceRealisePlanifie';
    WebHTMLDiv_RecapVacanceRealisePlanifie.Left := 15;
    WebHTMLDiv_RecapVacanceRealisePlanifie.Top := 373;
    WebHTMLDiv_RecapVacanceRealisePlanifie.Width := 375;
    WebHTMLDiv_RecapVacanceRealisePlanifie.Height := 28;
    WebHTMLDiv_RecapVacanceRealisePlanifie.Anchors := [];
    WebHTMLDiv_RecapVacanceRealisePlanifie.ChildOrder := 12;
    WebHTMLDiv_RecapVacanceRealisePlanifie.ElementPosition := epRelative;
    WebHTMLDiv_RecapVacanceRealisePlanifie.Role := '';
    WebHTMLDiv_RecapVacanceSoldeDispo.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv_RecapVacanceSoldeDispo.Name := 'WebHTMLDiv_RecapVacanceSoldeDispo';
    WebHTMLDiv_RecapVacanceSoldeDispo.Left := 15;
    WebHTMLDiv_RecapVacanceSoldeDispo.Top := 399;
    WebHTMLDiv_RecapVacanceSoldeDispo.Width := 375;
    WebHTMLDiv_RecapVacanceSoldeDispo.Height := 28;
    WebHTMLDiv_RecapVacanceSoldeDispo.Anchors := [];
    WebHTMLDiv_RecapVacanceSoldeDispo.ChildOrder := 13;
    WebHTMLDiv_RecapVacanceSoldeDispo.ElementPosition := epRelative;
    WebHTMLDiv_RecapVacanceSoldeDispo.Role := '';
    WebHTMLDiv5.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv5.Name := 'WebHTMLDiv5';
    WebHTMLDiv5.Left := 15;
    WebHTMLDiv5.Top := 3;
    WebHTMLDiv5.Width := 375;
    WebHTMLDiv5.Height := 16;
    WebHTMLDiv5.ElementPosition := epRelative;
    WebHTMLDiv5.ElementFont := efCSS;
    WebHTMLDiv5.Role := '';
    WebHTMLDiv6.SetParentComponent(WebHTMLDiv4);
    WebHTMLDiv6.Name := 'WebHTMLDiv6';
    WebHTMLDiv6.Left := 15;
    WebHTMLDiv6.Top := 277;
    WebHTMLDiv6.Width := 375;
    WebHTMLDiv6.Height := 16;
    WebHTMLDiv6.ChildOrder := 8;
    WebHTMLDiv6.ElementPosition := epRelative;
    WebHTMLDiv6.ElementFont := efCSS;
    WebHTMLDiv6.Role := '';
    WebPageControl_Main_Correction.SetParentComponent(WebPageControl_Main);
    WebPageControl_Main_Correction.Name := 'WebPageControl_Main_Correction';
    WebPageControl_Main_Correction.Left := 0;
    WebPageControl_Main_Correction.Top := 20;
    WebPageControl_Main_Correction.Width := 487;
    WebPageControl_Main_Correction.Height := 566;
    WebPageControl_Main_Correction.Center.Horizontal := True;
    WebPageControl_Main_Correction.WidthStyle := ssPercent;
    WebPageControl_Main_Correction.Align := alClient;
    WebPageControl_Main_Correction.Anchors := [];
    WebPageControl_Main_Correction.BorderStyle := bsNone;
    WebPageControl_Main_Correction.Caption := 'Correction';
    WebPageControl_Main_Correction.ChildOrder := 3;
    WebPageControl_Main_Correction.TabVisible := False;
    WebHTMLDiv8.SetParentComponent(WebPageControl_Main_Correction);
    WebHTMLDiv8.Name := 'WebHTMLDiv8';
    WebHTMLDiv8.Left := 0;
    WebHTMLDiv8.Top := 0;
    WebHTMLDiv8.Width := 487;
    WebHTMLDiv8.Height := 566;
    WebHTMLDiv8.Center.Horizontal := True;
    WebHTMLDiv8.ElementClassName := 'page-container';
    WebHTMLDiv8.WidthStyle := ssPercent;
    WebHTMLDiv8.Align := alClient;
    WebHTMLDiv8.Anchors := [];
    WebHTMLDiv8.ElementPosition := epRelative;
    WebHTMLDiv8.Role := '';
    WebHTMLDiv_Correction_Top.SetParentComponent(WebHTMLDiv8);
    WebHTMLDiv_Correction_Top.Name := 'WebHTMLDiv_Correction_Top';
    WebHTMLDiv_Correction_Top.Left := 0;
    WebHTMLDiv_Correction_Top.Top := 0;
    WebHTMLDiv_Correction_Top.Width := 487;
    WebHTMLDiv_Correction_Top.Height := 242;
    WebHTMLDiv_Correction_Top.Center.Horizontal := True;
    WebHTMLDiv_Correction_Top.WidthStyle := ssPercent;
    WebHTMLDiv_Correction_Top.Align := alTop;
    WebHTMLDiv_Correction_Top.ChildOrder := 7;
    WebHTMLDiv_Correction_Top.ElementPosition := epRelative;
    WebHTMLDiv_Correction_Top.Role := '';
    WebHTMLDiv9.SetParentComponent(WebHTMLDiv_Correction_Top);
    WebHTMLDiv9.Name := 'WebHTMLDiv9';
    WebHTMLDiv9.Left := 19;
    WebHTMLDiv9.Top := 3;
    WebHTMLDiv9.Width := 449;
    WebHTMLDiv9.Height := 233;
    WebHTMLDiv9.Center.Horizontal := True;
    WebHTMLDiv9.Anchors := [];
    WebHTMLDiv9.ChildOrder := 6;
    WebHTMLDiv9.Role := '';
    WebLabel1.SetParentComponent(WebHTMLDiv9);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 79;
    WebLabel1.Top := 22;
    WebLabel1.Width := 280;
    WebLabel1.Height := 37;
    WebLabel1.Anchors := [];
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Fin de pr'#233'sence oubli'#233'e';
    WebLabel1.ElementClassName := 'correction-titre-label';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -27;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebHTMLDiv9);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 97;
    WebLabel2.Top := 74;
    WebLabel2.Width := 35;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'D'#233'but:';
    WebLabel2.ElementClassName := 'correction-text-label';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel_Correction_DateHeure.SetParentComponent(WebHTMLDiv9);
    WebLabel_Correction_DateHeure.Name := 'WebLabel_Correction_DateHeure';
    WebLabel_Correction_DateHeure.Left := 163;
    WebLabel_Correction_DateHeure.Top := 74;
    WebLabel_Correction_DateHeure.Width := 174;
    WebLabel_Correction_DateHeure.Height := 15;
    WebLabel_Correction_DateHeure.Caption := 'WebLabel_Correction_DateHeure';
    WebLabel_Correction_DateHeure.ElementClassName := 'correction-text-label';
    WebLabel_Correction_DateHeure.HeightPercent := 100.000000000000000000;
    WebLabel_Correction_DateHeure.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebHTMLDiv9);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 62;
    WebLabel3.Top := 117;
    WebLabel3.Width := 368;
    WebLabel3.Height := 23;
    WebLabel3.Caption := 'Veuillez inscrire manuellement l'#39'heure de d'#233'part';
    WebLabel3.ElementClassName := 'correction-text-label';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -17;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebButton_Correction_Valider.SetParentComponent(WebHTMLDiv9);
    WebButton_Correction_Valider.Name := 'WebButton_Correction_Valider';
    WebButton_Correction_Valider.Left := 241;
    WebButton_Correction_Valider.Top := 160;
    WebButton_Correction_Valider.Width := 96;
    WebButton_Correction_Valider.Height := 25;
    WebButton_Correction_Valider.Caption := 'Valider';
    WebButton_Correction_Valider.ChildOrder := 4;
    WebButton_Correction_Valider.ElementClassName := 'btn btn-primary';
    WebButton_Correction_Valider.Font.Charset := DEFAULT_CHARSET;
    WebButton_Correction_Valider.Font.Color := clWindowText;
    WebButton_Correction_Valider.Font.Height := -20;
    WebButton_Correction_Valider.Font.Name := 'Segoe UI';
    WebButton_Correction_Valider.Font.Style := [];
    WebButton_Correction_Valider.HeightStyle := ssAuto;
    WebButton_Correction_Valider.HeightPercent := 100.000000000000000000;
    WebButton_Correction_Valider.ParentFont := False;
    WebButton_Correction_Valider.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_Correction_Valider, Self, 'OnClick', 'WebButton_Correction_ValiderClick');
    WebDateTimePicker_CorrectionHeure.SetParentComponent(WebHTMLDiv9);
    WebDateTimePicker_CorrectionHeure.Name := 'WebDateTimePicker_CorrectionHeure';
    WebDateTimePicker_CorrectionHeure.Left := 105;
    WebDateTimePicker_CorrectionHeure.Top := 161;
    WebDateTimePicker_CorrectionHeure.Width := 112;
    WebDateTimePicker_CorrectionHeure.Height := 37;
    WebDateTimePicker_CorrectionHeure.HeightStyle := ssAuto;
    WebDateTimePicker_CorrectionHeure.BorderStyle := bsSingle;
    WebDateTimePicker_CorrectionHeure.ChildOrder := 5;
    WebDateTimePicker_CorrectionHeure.Color := clWhite;
    WebDateTimePicker_CorrectionHeure.Date := 45902.692021724540000000;
    WebDateTimePicker_CorrectionHeure.Font.Charset := DEFAULT_CHARSET;
    WebDateTimePicker_CorrectionHeure.Font.Color := clWindowText;
    WebDateTimePicker_CorrectionHeure.Font.Height := -20;
    WebDateTimePicker_CorrectionHeure.Font.Name := 'Segoe UI';
    WebDateTimePicker_CorrectionHeure.Font.Style := [];
    WebDateTimePicker_CorrectionHeure.Kind := dtkTime;
    WebDateTimePicker_CorrectionHeure.ParentFont := False;
    WebDateTimePicker_CorrectionHeure.Role := '';
    WebDateTimePicker_CorrectionHeure.ShowSeconds := False;
    WebDateTimePicker_CorrectionHeure.Text := '';
    divTimbragesCorrection.SetParentComponent(WebHTMLDiv8);
    divTimbragesCorrection.Name := 'divTimbragesCorrection';
    divTimbragesCorrection.Left := 0;
    divTimbragesCorrection.Top := 242;
    divTimbragesCorrection.Width := 487;
    divTimbragesCorrection.Height := 324;
    divTimbragesCorrection.ElementClassName := 'timbrage-section';
    divTimbragesCorrection.WidthStyle := ssPercent;
    divTimbragesCorrection.Align := alClient;
    divTimbragesCorrection.Anchors := [];
    divTimbragesCorrection.ChildOrder := 11;
    divTimbragesCorrection.ElementPosition := epRelative;
    divTimbragesCorrection.Role := '';
    WebPageControl_Main_DemandeVac.SetParentComponent(WebPageControl_Main);
    WebPageControl_Main_DemandeVac.Name := 'WebPageControl_Main_DemandeVac';
    WebPageControl_Main_DemandeVac.Left := 0;
    WebPageControl_Main_DemandeVac.Top := 20;
    WebPageControl_Main_DemandeVac.Width := 487;
    WebPageControl_Main_DemandeVac.Height := 566;
    WebPageControl_Main_DemandeVac.Center.Horizontal := True;
    WebPageControl_Main_DemandeVac.WidthStyle := ssPercent;
    WebPageControl_Main_DemandeVac.Align := alClient;
    WebPageControl_Main_DemandeVac.Anchors := [];
    WebPageControl_Main_DemandeVac.BorderStyle := bsNone;
    WebPageControl_Main_DemandeVac.Caption := 'Demandes';
    WebPageControl_Main_DemandeVac.ChildOrder := 4;
    SetEvent(WebPageControl_Main_DemandeVac, Self, 'OnShow', 'WebTabSheet_DemandeVacShow');
    divDemandeVacContainer.SetParentComponent(WebPageControl_Main_DemandeVac);
    divDemandeVacContainer.Name := 'divDemandeVacContainer';
    divDemandeVacContainer.Left := 0;
    divDemandeVacContainer.Top := 0;
    divDemandeVacContainer.Width := 487;
    divDemandeVacContainer.Height := 566;
    divDemandeVacContainer.Center.Horizontal := True;
    divDemandeVacContainer.ElementClassName := 'page-container';
    divDemandeVacContainer.WidthStyle := ssPercent;
    divDemandeVacContainer.Align := alClient;
    divDemandeVacContainer.Anchors := [];
    divDemandeVacContainer.ElementPosition := epRelative;
    divDemandeVacContainer.Role := '';
    divDemandeForm.SetParentComponent(divDemandeVacContainer);
    divDemandeForm.Name := 'divDemandeForm';
    divDemandeForm.Left := 0;
    divDemandeForm.Top := 0;
    divDemandeForm.Width := 487;
    divDemandeForm.Height := 380;
    divDemandeForm.ElementClassName := 'demande-form-section';
    divDemandeForm.WidthStyle := ssPercent;
    divDemandeForm.Align := alTop;
    divDemandeForm.ElementPosition := epRelative;
    divDemandeForm.Role := '';
    divDemandesList.SetParentComponent(divDemandeVacContainer);
    divDemandesList.Name := 'divDemandesList';
    divDemandesList.Left := 0;
    divDemandesList.Top := 380;
    divDemandesList.Width := 487;
    divDemandesList.Height := 186;
    divDemandesList.ElementClassName := 'timbrage-section';
    divDemandesList.WidthStyle := ssPercent;
    divDemandesList.Align := alClient;
    divDemandesList.Anchors := [];
    divDemandesList.ChildOrder := 1;
    divDemandesList.ElementPosition := epRelative;
    divDemandesList.Role := '';
    WebHTMLDiv_EntetePresence.SetParentComponent(Self);
    WebHTMLDiv_EntetePresence.Name := 'WebHTMLDiv_EntetePresence';
    WebHTMLDiv_EntetePresence.Left := 0;
    WebHTMLDiv_EntetePresence.Top := 0;
    WebHTMLDiv_EntetePresence.Width := 487;
    WebHTMLDiv_EntetePresence.Height := 50;
    WebHTMLDiv_EntetePresence.Center.Horizontal := True;
    WebHTMLDiv_EntetePresence.ElementClassName := 'div-entete';
    WebHTMLDiv_EntetePresence.WidthStyle := ssPercent;
    WebHTMLDiv_EntetePresence.Align := alTop;
    WebHTMLDiv_EntetePresence.Anchors := [];
    WebHTMLDiv_EntetePresence.ElementPosition := epRelative;
    WebHTMLDiv_EntetePresence.Role := '';
    lblPresence.SetParentComponent(WebHTMLDiv_EntetePresence);
    lblPresence.Name := 'lblPresence';
    lblPresence.Left := 0;
    lblPresence.Top := 10;
    lblPresence.Width := 143;
    lblPresence.Height := 33;
    lblPresence.Anchors := [];
    lblPresence.AutoSize := False;
    lblPresence.ElementClassName := 'presence-label';
    lblPresence.Font.Charset := DEFAULT_CHARSET;
    lblPresence.Font.Color := clHighlightText;
    lblPresence.Font.Height := -12;
    lblPresence.Font.Name := 'Segoe UI';
    lblPresence.Font.Style := [];
    lblPresence.HeightPercent := 80.000000000000000000;
    lblPresence.ParentFont := False;
    lblPresence.WidthPercent := 100.000000000000000000;
    WebHTMLDiv7.SetParentComponent(WebHTMLDiv_EntetePresence);
    WebHTMLDiv7.Name := 'WebHTMLDiv7';
    WebHTMLDiv7.Left := 301;
    WebHTMLDiv7.Top := -6;
    WebHTMLDiv7.Width := 186;
    WebHTMLDiv7.Height := 35;
    WebHTMLDiv7.ElementClassName := 'divHeader';
    WebHTMLDiv7.WidthStyle := ssAuto;
    WebHTMLDiv7.Anchors := [akRight];
    WebHTMLDiv7.ChildOrder := 3;
    WebHTMLDiv7.ElementPosition := epIgnore;
    WebHTMLDiv7.ElementFont := efCSS;
    WebHTMLDiv7.Role := '';
    btnLogout.SetParentComponent(WebHTMLDiv7);
    btnLogout.Name := 'btnLogout';
    btnLogout.Left := 19;
    btnLogout.Top := -6;
    btnLogout.Width := 164;
    btnLogout.Height := 32;
    btnLogout.Anchors := [];
    btnLogout.ChildOrder := 1;
    btnLogout.ElementClassName := 'logout-button';
    btnLogout.ElementFont := efCSS;
    btnLogout.ElementPosition := epIgnore;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.Visible := False;
    btnLogout.WidthStyle := ssAuto;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    WebButton_DarkLight.SetParentComponent(WebHTMLDiv_EntetePresence);
    WebButton_DarkLight.Name := 'WebButton_DarkLight';
    WebButton_DarkLight.Left := 150;
    WebButton_DarkLight.Top := 9;
    WebButton_DarkLight.Width := 43;
    WebButton_DarkLight.Height := 32;
    WebButton_DarkLight.Caption := 'WebButton_DarkLight';
    WebButton_DarkLight.ChildOrder := 2;
    WebButton_DarkLight.HeightPercent := 100.000000000000000000;
    WebButton_DarkLight.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton_DarkLight, Self, 'OnClick', 'WebButton_DarkLightClick');
    LocalStorage1.SetParentComponent(Self);
    LocalStorage1.Name := 'LocalStorage1';
    LocalStorage1.Left := 344;
    LocalStorage1.Top := 126;
  finally
    WebPageControl_Main.AfterLoadDFMValues;
    WebPageControl_Main_Identification.AfterLoadDFMValues;
    WebHTMLDiv2.AfterLoadDFMValues;
    WebHTMLDiv3.AfterLoadDFMValues;
    lbl_identifiant.AfterLoadDFMValues;
    edtUsername.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    WebPageControl_Main_Presence.AfterLoadDFMValues;
    WebHTMLDiv1.AfterLoadDFMValues;
    divTileContainer.AfterLoadDFMValues;
    divPresenceDebutBtn.AfterLoadDFMValues;
    divPresenceFinBtn.AfterLoadDFMValues;
    divPauseDebutBtn.AfterLoadDFMValues;
    divPauseFinBtn.AfterLoadDFMValues;
    divTimbrages.AfterLoadDFMValues;
    WebTabSheet_Recapitulatif.AfterLoadDFMValues;
    WebHTMLDiv4.AfterLoadDFMValues;
    WebHTMLDiv_RecapTitre.AfterLoadDFMValues;
    WebHTMLDiv_RecapSoldeDuJour.AfterLoadDFMValues;
    WebHTMLDiv_RecapSemainePrevu.AfterLoadDFMValues;
    WebHTMLDiv_RecapSemaineRealise.AfterLoadDFMValues;
    WebHTMLDiv_RecapSemaineSolde.AfterLoadDFMValues;
    WebHTMLDiv_RecapMoisEncours.AfterLoadDFMValues;
    WebHTMLDiv_RecapAnneeEnCours.AfterLoadDFMValues;
    WebHTMLDiv_RecapTitreVacance.AfterLoadDFMValues;
    WebHTMLDiv_RecapVacanceConvenu.AfterLoadDFMValues;
    WebHTMLDiv_RecapVacanceSoldeMois1.AfterLoadDFMValues;
    WebHTMLDiv_RecapVacanceRealisePlanifie.AfterLoadDFMValues;
    WebHTMLDiv_RecapVacanceSoldeDispo.AfterLoadDFMValues;
    WebHTMLDiv5.AfterLoadDFMValues;
    WebHTMLDiv6.AfterLoadDFMValues;
    WebPageControl_Main_Correction.AfterLoadDFMValues;
    WebHTMLDiv8.AfterLoadDFMValues;
    WebHTMLDiv_Correction_Top.AfterLoadDFMValues;
    WebHTMLDiv9.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel_Correction_DateHeure.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebButton_Correction_Valider.AfterLoadDFMValues;
    WebDateTimePicker_CorrectionHeure.AfterLoadDFMValues;
    divTimbragesCorrection.AfterLoadDFMValues;
    WebPageControl_Main_DemandeVac.AfterLoadDFMValues;
    divDemandeVacContainer.AfterLoadDFMValues;
    divDemandeForm.AfterLoadDFMValues;
    divDemandesList.AfterLoadDFMValues;
    WebHTMLDiv_EntetePresence.AfterLoadDFMValues;
    lblPresence.AfterLoadDFMValues;
    WebHTMLDiv7.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    WebButton_DarkLight.AfterLoadDFMValues;
    LocalStorage1.AfterLoadDFMValues;
  end;
end;

end.
